<template>
    <div class="trabalhe-page">
        <HomeHeader />

        <!-- Hero Section com Efeito Parallax -->
        <section class="hero-section">
            <div class="parallax-container">
                <div class="overlay"></div>
            </div>
        </section>

        <!-- Seção de Introdução -->
        <section class="intro-section">
            <div class="watermark-side watermark-side-right"></div>
            <div class="container">
                <ScrollReveal direction="bottom" :delay="100">
                    <div class="section-title">
                        <span class="accent-line"></span>
                        <h2>{{ t('career.introTitle') }}</h2>
                        <span class="accent-line"></span>
                    </div>
                    <p class="intro-text">
                        {{ t('career.introText') }}<br><br>
                        <span class="intro-text-two">{{ t('career.introText2') }}</span>
                    </p>
                </ScrollReveal>
            </div>
        </section>

        <!-- Seção de Mulheres Liderando -->
        <section class="women-section">
            <!-- Elementos decorativos animados -->
            <div class="women-decorative-elements">
                <div class="floating-shape shape-1"></div>
                <div class="floating-shape shape-2"></div>
                <div class="floating-shape shape-3"></div>
                <div class="geometric-element geo-1"></div>
                <div class="geometric-element geo-2"></div>
                <div class="geometric-element geo-3"></div>
                <div class="geometric-element geo-4"></div>
                <div class="line-element line-1"></div>
                <div class="line-element line-2"></div>
            </div>

            <div class="container">
                <!-- Header com estatísticas -->
                <ScrollReveal direction="bottom" :delay="200">
                    <div class="women-header">
                        <!-- Decorativos no canto superior esquerdo -->
                        <div class="header-decoration-elements">
                            <div class="deco-circle deco-1"></div>
                            <div class="deco-circle deco-2"></div>
                            <div class="deco-line deco-line-1"></div>
                            <div class="deco-line deco-line-2"></div>
                        </div>

                        <div class="section-title">
                            <span class="accent-line"></span>
                            <h2>{{ t('career.values.title') }}</h2>
                            <span class="accent-line"></span>
                        </div>

                        <!-- <div class="women-stats">
                            <div class="stat-item">
                                <div class="stat-number">{{ t('career.women.stats.femaleLeadership.number') }}</div>
                                <div class="stat-label">{{ t('career.women.stats.femaleLeadership.label') }}</div>
                            </div>
                            <div class="stat-divider"></div>
                            <div class="stat-item">
                                <div class="stat-number">{{ t('career.women.stats.diversity.number') }}</div>
                                <div class="stat-label">{{ t('career.women.stats.diversity.label') }}</div>
                            </div>
                            <div class="stat-divider"></div>
                            <div class="stat-item">
                                <div class="stat-number">{{ t('career.women.stats.salaryEquity.number') }}</div>
                                <div class="stat-label">{{ t('career.women.stats.salaryEquity.label') }}</div>
                            </div>
                        </div> -->

                        <!-- <p class="women-description">{{ t('career.women.description') }}</p> -->
                    </div>
                </ScrollReveal>

                <!-- Grid de conteúdo em escada -->
                <div class="women-staircase-grid">
                    <!-- Card 1 - Esquerda -->
                    <ScrollReveal direction="left" :delay="300">
                        <div class="staircase-item left-side">
                            <div class="highlight-card card-premium">
                                <div class="card-badge">{{ t('career.women.highlights.leadership.badge') }}</div>
                                <div class="highlight-icon">
                                    <i class="fas fa-compass"></i>
                                </div>
                                <h3>{{ t('career.values.integrity.title') }}</h3>
                                <p>{{ t('career.values.integrity.description') }}</p>
                            </div>
                        </div>
                    </ScrollReveal>

                    <!-- Card 2 - Direita com imagem ilustrativa -->
                    <ScrollReveal direction="right" :delay="370">
                        <div class="staircase-item right-side">
                            <div class="highlight-card card-premium">
                                <div class="card-badge">{{ t('career.women.highlights.growth.badge2') }}</div>
                                <div class="highlight-icon">
                                    <i class="fas fa-handshake"></i>
                                </div>
                                <h3>{{ t('career.values.collaboration.title') }}</h3>
                                <p>{{ t('career.values.collaboration.description') }}</p>
                            </div>
                        </div>
                    </ScrollReveal>

                    <!-- Card 3 - Esquerda -->
                    <ScrollReveal direction="left" :delay="440">
                        <div class="staircase-item left-side">
                            <div class="highlight-card card-premium">
                                <div class="card-badge">{{ t('career.women.highlights.support.badge1') }}</div>
                                <div class="highlight-icon">
                                    <i class="fas fa-lightbulb"></i>
                                </div>
                                <h3>{{ t('career.values.innovation.title') }}</h3>
                                <p>{{ t('career.values.innovation.description') }}</p>
                            </div>
                        </div>
                    </ScrollReveal>

                    <!-- Card 4 - Direita -->
                    <ScrollReveal direction="right" :delay="510">
                        <div class="staircase-item right-side">
                            <div class="highlight-card card-premium">
                                <div class="card-badge">{{ t('career.women.highlights.growth.badge1') }}</div>
                                <div class="highlight-icon">
                                    <i class="fas fa-award"></i>
                                </div>
                                <h3>{{ t('career.values.excellence.title') }}</h3>
                                <p>{{ t('career.values.excellence.description') }}</p>
                            </div>
                        </div>
                    </ScrollReveal>

                    <!-- Card 5 - Esquerda -->
                        <ScrollReveal direction="left" :delay="580">
                            <div class="staircase-item left-side">
                                <div class="highlight-card card-premium">
                                    <div class="card-badge">{{ t('career.women.femalePresenceBadge') }}</div>
                                    <div class="highlight-icon">
                                        <i class="fas fa-venus"></i>
                                    </div>
                                    <h3>{{ t('career.women.highlights.growth.title') }}</h3>
                                    <p>{{ t('career.women.femalePresenceDescription') }}</p>
                                </div>
                            </div>
                        </ScrollReveal>

                <!-- Card 6 - Direita -->
                    <ScrollReveal direction="right" :delay="650">
                        <div class="staircase-item right-side">
                            <div class="highlight-card card-premium">
                                <div class="card-badge">{{ t('career.women.highlights.support.badge2') }}</div>
                                <div class="highlight-icon">
                                    <i class="fas fa-heart"></i>
                                </div>
                                <h3>{{ t('career.women.highlights.support.title') }}</h3>
                                <p>{{ t('career.women.highlights.support.description') }}</p>
                            </div>
                        </div>
                    </ScrollReveal>
                    </div>

                <!-- Ilustração Flutuante ao Fundo -->
                <div class="women-floating-illustration">
                    <div class="illustration">
                        <div class="illustration-item item-1">
                            <i class="fas fa-users"></i>
                        </div>
                        <div class="illustration-item item-2">
                            <i class="fas fa-briefcase"></i>
                        </div>
                        <div class="illustration-item item-3">
                            <i class="fas fa-rocket"></i>
                        </div>
                        <div class="illustration-item item-4">
                            <i class="fas fa-star"></i>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Seção de Valores da Empresa -->
        <!-- <section class="values-section">
            <div class="container">
                <ScrollReveal direction="bottom" :delay="200">
                    <div class="section-title">
                        <span class="accent-line"></span>
                        <h2>{{ t('career.values.title') }}</h2>
                        <span class="accent-line"></span>
                    </div>
                </ScrollReveal>

                <div class="values-grid">
                    <ScrollReveal direction="bottom" :delay="300">
                        <div class="value-card">
                            <div class="value-icon">
                                <i class="fas fa-handshake"></i>
                            </div>
                            <h3>{{ t('career.values.integrity.title') }}</h3>
                            <p>{{ t('career.values.integrity.description') }}</p>
                        </div>
                    </ScrollReveal>

                    <ScrollReveal direction="bottom" :delay="400">
                        <div class="value-card">
                            <div class="value-icon">
                                <i class="fas fa-users"></i>
                            </div>
                            <h3>{{ t('career.values.collaboration.title') }}</h3>
                            <p>{{ t('career.values.collaboration.description') }}</p>
                        </div>
                    </ScrollReveal>

                    <ScrollReveal direction="bottom" :delay="500">
                        <div class="value-card">
                            <div class="value-icon">
                                <i class="fas fa-lightbulb"></i>
                            </div>
                            <h3>{{ t('career.values.innovation.title') }}</h3>
                            <p>{{ t('career.values.innovation.description') }}</p>
                        </div>
                    </ScrollReveal>

                    <ScrollReveal direction="bottom" :delay="600">
                        <div class="value-card">
                            <div class="value-icon">
                                <i class="fas fa-chart-line"></i>
                            </div>
                            <h3>{{ t('career.values.excellence.title') }}</h3>
                            <p>{{ t('career.values.excellence.description') }}</p>
                        </div>
                    </ScrollReveal>
                </div>
            </div>
        </section> -->

        <!-- Seção de Benefícios -->
        <!-- <section class="benefits-section">
      <div class="container">
        <ScrollReveal direction="bottom" :delay="200">
          <div class="section-title light">
            <span class="accent-line"></span>
            <h2>Benefícios de Trabalhar Conosco</h2>
            <span class="accent-line"></span>
          </div>
        </ScrollReveal>

        <div class="benefits-container">
          <ScrollReveal direction="left" :delay="300">
            <div class="benefits-image">
              <img src="@/assets/trabalhe-conosco.jpg" alt="Equipe Uni Hospitalar" />
            </div>
          </ScrollReveal>

          <ScrollReveal direction="right" :delay="400">
            <div class="benefits-list">
              <div class="benefit-item">
                <div class="benefit-icon">
                  <i class="fas fa-medal"></i>
                </div>
                <div class="benefit-content">
                  <h4>Plano de Carreira</h4>
                  <p>Oportunidades de crescimento e desenvolvimento profissional.</p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon">
                  <i class="fas fa-heartbeat"></i>
                </div>
                <div class="benefit-content">
                  <h4>Plano de Saúde</h4>
                  <p>Assistência médica e odontológica para você e seus dependentes.</p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon">
                  <i class="fas fa-graduation-cap"></i>
                </div>
                <div class="benefit-content">
                  <h4>Capacitação Contínua</h4>
                  <p>Programas de treinamento e desenvolvimento de habilidades.</p>
                </div>
              </div>

              <div class="benefit-item">
                <div class="benefit-icon">
                  <i class="fas fa-gift"></i>
                </div>
                <div class="benefit-content">
                  <h4>Pacote de Benefícios</h4>
                  <p>Vale-alimentação, vale-transporte e outros benefícios competitivos.</p>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section> -->

        <!-- Seção de Vagas Disponíveis -->
        <section class="jobs-section">
            <div class="watermark-side watermark-side-left"></div>
            <div class="container">
                <ScrollReveal direction="bottom" :delay="200">
                    <div class="section-title">
                        <span class="accent-line"></span>
                        <h2>{{ t('career.jobs.title') }}</h2>
                        <span class="accent-line"></span>
                    </div>
                    <p class="jobs-intro">
                        {{ t('career.jobs.intro') }}
                    </p>
                </ScrollReveal>

                <!-- Loading das vagas -->
                <div v-if="loadingJobs" class="loading-container">
                    <div class="loading-spinner">
                        <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <p>{{ t('career.jobs.loading') }}</p>
                </div>

                <!-- Lista de vagas -->
                <div v-else-if="availableJobs.length > 0" class="jobs-grid">
                    <ScrollReveal direction="bottom" :delay="300 + (index * 100)" v-for="(job, index) in availableJobs"
                        :key="job.id">
                        <div class="job-card" @click="selectJob(job)">
                            <div class="job-header">
                                <div class="job-icon">
                                    <i :class="getJobIcon(job.department)"></i>
                                </div>
                                <div class="job-badge" :class="getJobBadgeClass(job.type)">
                                    {{ job.type }}
                                </div>
                            </div>

                            <div class="job-content">
                                <h3 class="job-title">{{ job.title }}</h3>

                                <div class="job-info">
                                    <div class="job-detail">
                                        <i class="fas fa-building"></i>
                                        <span>{{ job.department }}</span>
                                    </div>
                                    <div class="job-detail">
                                        <i class="fas fa-map-marker-alt"></i>
                                        <span>{{ job.location }}</span>
                                    </div>
                                    <div class="job-detail">
                                        <i class="fas fa-clock"></i>
                                        <span>{{ job.workload }}</span>
                                    </div>
                                    <div class="job-detail" v-if="job.salary">
                                        <i class="fas fa-money-bill-wave"></i>
                                        <span>{{ job.salary }}</span>
                                    </div>
                                </div>

                                <!-- Seção de Descrição (Resumida + Completa) -->
                                <div class="job-description-section" v-if="job.shortDescription || job.description">
                                    <h4>{{ t('career.jobs.sections.description') }}</h4>

                                    <!-- Sempre mostra a descrição resumida se existir -->
                                    <div v-if="job.shortDescription" class="short-description">
                                        <div class="job-description" v-html="sanitizeHtml(job.shortDescription)"></div>
                                    </div>

                                    <!-- Se não tiver descrição resumida, mostra a completa como padrão -->
                                    <div v-else-if="job.description && !expandedSections[`desc-${job.id}`]"
                                        class="short-description">
                                        <div class="job-description" v-html="sanitizeHtml(job.description)"></div>
                                    </div>

                                    <!-- Descrição completa - só aparece quando expandida E quando existe shortDescription -->
                                    <div v-if="job.description && job.shortDescription && expandedSections[`desc-${job.id}`]"
                                        class="complete-description">
                                        <h5 class="complete-description-title">{{
                                            t('career.jobs.sections.detailedDescription') }}</h5>
                                        <div class="job-description-complete" v-html="sanitizeHtml(job.description)"></div>
                                    </div>

                                    <!-- Botão para expandir - só aparece se tiver AMBAS as descrições -->
                                    <button v-if="job.description && job.shortDescription"
                                        @click.stop="toggleSection(`desc-${job.id}`)" class="expand-button">
                                        {{ expandedSections[`desc-${job.id}`] ?
                                            t('career.jobs.expandButtons.seeLessDetails') :
                                            t('career.jobs.expandButtons.seeComplete') }}
                                        <i
                                            :class="expandedSections[`desc-${job.id}`] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                    </button>
                                </div>

                                <!-- Requisitos Principais -->
                                <div class="job-requirements"
                                    v-if="job.mainRequirements && job.mainRequirements.length > 0">
                                    <h4>{{ t('career.jobs.sections.mainRequirements') }}</h4>
                                    <div class="expandable-content"
                                        :class="{ 'expanded': expandedSections[`main-req-${job.id}`] }">
                                        <ul class="requirements-list">
                                            <li v-for="(requirement, idx) in job.mainRequirements" :key="idx"
                                                v-show="expandedSections[`main-req-${job.id}`] || idx < 3">
                                                {{ requirement }}
                                            </li>
                                        </ul>
                                        <button v-if="job.mainRequirements.length > 3"
                                            @click.stop="toggleSection(`main-req-${job.id}`)" class="expand-button">
                                            {{ expandedSections[`main-req-${job.id}`] ?
                                                t('career.jobs.expandButtons.seeLess') :
                                                `${t('career.jobs.expandButtons.seeMore')} ${job.mainRequirements.length -
                                                3} ${t('career.jobs.expandButtons.moreRequirements')}` }}
                                            <i
                                                :class="expandedSections[`main-req-${job.id}`] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Requisitos Adicionais -->
                                <div class="job-additional-requirements"
                                    v-if="job.additionalRequirements && job.additionalRequirements.length > 0">
                                    <h4>{{ t('career.jobs.sections.additionalRequirements') }}</h4>
                                    <div class="expandable-content"
                                        :class="{ 'expanded': expandedSections[`add-req-${job.id}`] }">
                                        <ul class="additional-requirements-list">
                                            <li v-for="(requirement, idx) in job.additionalRequirements" :key="idx"
                                                v-show="expandedSections[`add-req-${job.id}`] || idx < 2">
                                                {{ requirement }}
                                            </li>
                                        </ul>
                                        <button v-if="job.additionalRequirements.length > 2"
                                            @click.stop="toggleSection(`add-req-${job.id}`)" class="expand-button">
                                            {{ expandedSections[`add-req-${job.id}`] ?
                                                t('career.jobs.expandButtons.seeLess') :
                                                `${t('career.jobs.expandButtons.seeMore')}
                                            ${job.additionalRequirements.length - 2}
                                            ${t('career.jobs.expandButtons.moreRequirements')}` }}
                                            <i
                                                :class="expandedSections[`add-req-${job.id}`] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                        </button>
                                    </div>
                                </div>

                                <!-- Benefícios -->
                                <div class="job-benefits-preview" v-if="job.benefits && job.benefits.length > 0">
                                    <h4>{{ t('career.jobs.sections.benefits') }}</h4>
                                    <div class="expandable-content"
                                        :class="{ 'expanded': expandedSections[`benefits-${job.id}`] }">
                                        <ul class="benefits-list">
                                            <li v-for="(benefit, idx) in job.benefits" :key="idx"
                                                v-show="expandedSections[`benefits-${job.id}`] || idx < 3">
                                                {{ benefit }}
                                            </li>
                                        </ul>
                                        <button v-if="job.benefits.length > 3"
                                            @click.stop="toggleSection(`benefits-${job.id}`)" class="expand-button">
                                            {{ expandedSections[`benefits-${job.id}`] ?
                                                t('career.jobs.expandButtons.seeLess') :
                                                `${t('career.jobs.expandButtons.seeMore')} ${job.benefits.length - 3}
                                            ${t('career.jobs.expandButtons.moreBenefits')}` }}
                                            <i
                                                :class="expandedSections[`benefits-${job.id}`] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="job-footer">
                                <button class="apply-button">
                                    <i class="fas fa-paper-plane"></i>
                                    {{ t('career.jobs.applyButton') }}
                                </button>
                            </div>
                        </div>
                    </ScrollReveal>
                </div>

                <!-- Mensagem quando não há vagas -->
                <div v-else class="no-jobs-container">
                    <ScrollReveal direction="bottom" :delay="300">
                        <div class="no-jobs-content">
                            <div class="no-jobs-icon">
                                <i class="fas fa-search"></i>
                            </div>
                            <h3>{{ t('career.jobs.noJobs.title') }}</h3>
                            <p>
                                {{ t('career.jobs.noJobs.description') }}
                            </p>
                            <button @click="showTalentBankForm" class="talent-bank-button">
                                <i class="fas fa-database"></i>
                                {{ t('career.jobs.noJobs.talentBankButton') }}
                            </button>
                        </div>
                    </ScrollReveal>
                </div>
            </div>
        </section>

        <!-- Seção de Formulário (oculta inicialmente) -->
        <section class="form-section" v-if="showForm">
            <div class="container">
                <ScrollReveal direction="bottom" :delay="200">
                    <div class="section-title">
                        <span class="accent-line"></span>
                        <h2 v-if="selectedJob">{{ t('career.form.applicationTitle') }} {{ selectedJob.title }}</h2>
                        <h2 v-else>{{ t('career.form.talentBankTitle') }}</h2>
                        <span class="accent-line"></span>
                    </div>
                    <div class="selected-job-info" v-if="selectedJob">
                        <div class="job-summary">
                            <div class="job-summary-header">
                                <h3>{{ selectedJob.title }}</h3>
                                <button @click="backToJobs" class="back-button">
                                    <i class="fas fa-arrow-left"></i>
                                    {{ t('career.form.backToJobs') }}
                                </button>
                            </div>
                            <div class="job-summary-details">
                                <span><i class="fas fa-building"></i> {{ selectedJob.department }}</span>
                                <span><i class="fas fa-map-marker-alt"></i> {{ selectedJob.location }}</span>
                                <span><i class="fas fa-clock"></i> {{ selectedJob.workload }}</span>
                                <span><i class="fas fa-money-bill-wave"></i> {{ selectedJob.salary }}</span>
                            </div>
                        </div>
                    </div>
                    <p class="form-intro" v-if="selectedJob">
                        {{ t('career.form.applicationIntro') }}
                    </p>
                    <p class="form-intro" v-else>
                        {{ t('career.form.talentBankIntro') }}
                    </p>
                </ScrollReveal>

                <ScrollReveal direction="bottom" :delay="300">
                    <div class="form-container">
                        <div class="form-header">
                            <div class="form-icon">
                                <i class="fas fa-briefcase"></i>
                            </div>
                            <h3 v-if="selectedJob">{{ t('career.form.applicationTitle') }} {{ selectedJob.title }}</h3>
                            <h3 v-else>{{ t('career.form.talentBankTitle') }}</h3>
                        </div>
                        <form @submit.prevent="submitForm" class="career-form">
                            <div class="form-grid">
                                <div class="form-group">
                                    <label for="name">{{ t('career.form.fields.name.label') }}</label>
                                    <input type="text" id="name" v-model="formData.name" required
                                        :placeholder="t('career.form.fields.name.placeholder')">
                                    <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
                                </div>

                                <div class="form-group">
                                    <label for="email">{{ t('career.form.fields.email.label') }}</label>
                                    <input type="email" id="email" v-model="formData.email" required
                                        :placeholder="t('career.form.fields.email.placeholder')">
                                    <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
                                </div>

                                <div class="form-group">
                                    <label for="phone">{{ t('career.form.fields.phone.label') }}</label>
                                    <input type="tel" id="phone" v-model="formData.phone" required
                                        :placeholder="t('career.form.fields.phone.placeholder')" @input="formatPhone"
                                        maxlength="15">
                                    <span class="error-message" v-if="errors.phone">{{ errors.phone }}</span>
                                </div>

                                <div class="form-group" v-if="!selectedJob">
                                    <label for="position">{{ t('career.form.fields.position.label') }}</label>
                                    <select id="position" v-model="formData.position" required>
                                        <option value="" disabled selected>{{
                                            t('career.form.fields.position.placeholder') }}</option>
                                        <option value="Administrativo">{{
                                            t('career.form.fields.position.options.administrative') }}</option>
                                        <option value="Comercial">{{ t('career.form.fields.position.options.commercial')
                                        }}</option>
                                        <option value="Estoque">{{ t('career.form.fields.position.options.inventory') }}
                                        </option>
                                        <option value="Financeiro">{{ t('career.form.fields.position.options.financial')
                                        }}</option>
                                        <option value="Fiscal">{{ t('career.form.fields.position.options.fiscal') }}
                                        </option>
                                        <option value="Licitação">{{ t('career.form.fields.position.options.bidding') }}
                                        </option>
                                        <option value="Logística">{{ t('career.form.fields.position.options.logistics')
                                        }}</option>
                                        <option value="TI">{{ t('career.form.fields.position.options.it') }}</option>
                                        <option value="Outro">{{ t('career.form.fields.position.options.other') }}
                                        </option>
                                    </select>
                                    <span class="error-message" v-if="errors.position">{{ errors.position }}</span>
                                </div>

                                <div class="form-group">
                                    <label for="education">{{ t('career.form.fields.education.label') }}</label>
                                    <select id="education" v-model="formData.education" required>
                                        <option value="" disabled selected>{{
                                            t('career.form.fields.education.placeholder') }}</option>
                                        <option value="Ensino Médio">{{
                                            t('career.form.fields.education.options.highSchool') }}</option>
                                        <option value="Ensino Técnico">{{
                                            t('career.form.fields.education.options.technical') }}</option>
                                        <option value="Ensino Superior Incompleto">{{
                                            t('career.form.fields.education.options.universityIncomplete') }}</option>
                                        <option value="Ensino Superior Completo">{{
                                            t('career.form.fields.education.options.universityComplete') }}</option>
                                        <option value="Pós-graduação">{{
                                            t('career.form.fields.education.options.postGrad') }}</option>
                                        <option value="Mestrado">{{ t('career.form.fields.education.options.masters') }}
                                        </option>
                                        <option value="Doutorado">{{ t('career.form.fields.education.options.doctorate')
                                        }}</option>
                                    </select>
                                    <span class="error-message" v-if="errors.education">{{ errors.education }}</span>
                                </div>

                                <div class="form-group">
                                    <label for="experience">{{ t('career.form.fields.experience.label') }}</label>
                                    <select id="experience" v-model="formData.experience" required>
                                        <option value="" disabled selected>{{
                                            t('career.form.fields.experience.placeholder') }}</option>
                                        <option value="Sem experiência">{{
                                            t('career.form.fields.experience.options.noExperience') }}</option>
                                        <option value="Até 1 ano">{{
                                            t('career.form.fields.experience.options.upTo1Year') }}</option>
                                        <option value="1 a 3 anos">{{
                                            t('career.form.fields.experience.options.from1To3Years') }}</option>
                                        <option value="3 a 5 anos">{{
                                            t('career.form.fields.experience.options.from3To5Years') }}</option>
                                        <option value="5 a 10 anos">{{
                                            t('career.form.fields.experience.options.from5To10Years') }}</option>
                                        <option value="Mais de 10 anos">{{
                                            t('career.form.fields.experience.options.moreThan10Years') }}</option>
                                    </select>
                                    <span class="error-message" v-if="errors.experience">{{ errors.experience }}</span>
                                </div>
                            </div>

                            <div class="form-group full-width">
                                <label for="resume">{{ t('career.form.fields.resume.label') }}</label>
                                <div class="file-upload-container">
                                    <input type="file" id="resume" ref="resumeFile" @change="handleFileUpload"
                                        accept=".pdf" required class="file-input">
                                    <label for="resume" class="file-upload-label">
                                        <i class="fas fa-cloud-upload-alt"></i>
                                        <span v-if="!formData.resume">{{ t('career.form.fields.resume.placeholder')
                                        }}</span>
                                        <span v-else>{{ formData.resume.name }}</span>
                                    </label>
                                </div>
                                <span class="error-message" v-if="errors.resume">{{ errors.resume }}</span>
                            </div>

                            <div class="form-group full-width">
                                <label for="message">{{ t('career.form.fields.message.label') }}</label>
                                <textarea id="message" v-model="formData.message" required rows="6"
                                    :placeholder="t('career.form.fields.message.placeholder')"></textarea>
                                <span class="error-message" v-if="errors.message">{{ errors.message }}</span>
                            </div>

                            <div class="form-group full-width optional-field">
                                <label for="expectations">{{ t('career.form.fields.expectations.label') }}</label>
                                <input type="text" id="expectations" v-model="formData.expectations"
                                    :placeholder="t('career.form.fields.expectations.placeholder')">
                            </div>

                            <div class="form-group full-width optional-field">
                                <div class="checkbox-group">
                                    <input type="checkbox" id="privacy" v-model="formData.privacy">
                                    <label for="privacy">
                                        {{ t('career.form.fields.privacy.label') }}
                                    </label>
                                </div>
                                <div class="privacy-disclaimer">
                                    <div class="notice-content">
                                        <i class="fas fa-info-circle notice-icon"></i>
                                        <p>
                                            {{ t('career.form.fields.privacy.disclaimer1') }}
                                        </p>
                                    </div>

                                    <div class="notice-content">
                                        <i class="fas fa-external-link-alt notice-icon"></i>
                                        <p>
                                            {{ t('career.form.fields.privacy.disclaimer2') }}
                                            <a href="/documentos_site/Aviso de Privacidade - Uni Hospitalar.pdf" target="_blank">{{
                                                t('career.form.fields.privacy.privacyNoticeLink') }}</a>.
                                        </p>
                                    </div>
                                </div>
                                <span class="error-message" v-if="errors.privacy">{{ errors.privacy }}</span>
                            </div>

                            <div class="form-actions">
                                <button type="button" @click="backToJobs" class="cancel-button">
                                    <i class="fas fa-times"></i>
                                    {{ t('career.form.buttons.cancel') }}
                                </button>
                                <button type="submit" class="submit-button" :disabled="isSubmitting">
                                    <i class="fas fa-paper-plane" v-if="!isSubmitting"></i>
                                    <i class="fas fa-spinner fa-spin" v-else></i>
                                    {{ isSubmitting ? t('career.form.buttons.submitting') :
                                        t('career.form.buttons.submit') }}
                                </button>
                            </div>
                        </form>
                    </div>
                </ScrollReveal>
            </div>
        </section>

        <!-- Modal de Sucesso -->
        <div v-if="showSuccessModal" class="success-modal-overlay">
            <div class="success-modal-content" @keydown.esc.prevent>
                <div class="success-animation">
                    <div class="checkmark-container">
                        <div class="checkmark-circle">
                            <i class="fas fa-check checkmark-icon"></i>
                        </div>
                        <div class="celebration-particles">
                            <div class="particle" v-for="n in 12" :key="n"></div>
                        </div>
                    </div>
                </div>

                <div class="success-content">
                    <h2 class="success-title">{{ isApplicationSubmission ? t('career.success.applicationTitle') :
                        t('career.success.talentBankTitle') }}</h2>
                    <p class="success-message">{{ isApplicationSubmission ? t('career.success.applicationMessage') :
                        t('career.success.talentBankMessage') }}</p>

                    <div class="success-details" v-if="isApplicationSubmission">
                        <div class="job-applied">
                            <i class="fas fa-briefcase"></i>
                            <span class="job-applied-span">{{ selectedJobTitle }}</span>
                        </div>
                        <div class="next-steps">
                            <h4>{{ t('career.success.nextSteps.title') }}</h4>
                            <ul>
                                <li><i class="fas fa-envelope"></i> {{
                                    t('career.success.nextSteps.application.confirmation') }}</li>
                                <li><i class="fas fa-search"></i> {{ t('career.success.nextSteps.application.analysis')
                                }}</li>
                                <li><i class="fas fa-phone"></i> {{ t('career.success.nextSteps.application.contact') }}
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="success-details" v-else>
                        <div class="talent-bank">
                            <i class="fas fa-database"></i>
                            <span class="talent-bank-span">{{ t('career.form.talentBankTitle') }}</span>
                        </div>
                        <div class="next-steps">
                            <h4>{{ t('career.success.nextSteps.talentBank.title') }}</h4>
                            <ul>
                                <li><i class="fas fa-save"></i> {{ t('career.success.nextSteps.talentBank.saved') }}
                                </li>
                                <li><i class="fas fa-bell"></i> {{
                                    t('career.success.nextSteps.talentBank.notifications') }}</li>
                                <li><i class="fas fa-heart"></i> {{ t('career.success.nextSteps.talentBank.contact') }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="success-actions">
                    <button @click="closeSuccessModal" class="success-button">
                        <i class="fas fa-home"></i>
                        {{ t('career.success.buttons.backHome') }}
                    </button>
                    <button @click="viewMoreJobs" class="secondary-button" v-if="isApplicationSubmission">
                        <i class="fas fa-search"></i>
                        {{ t('career.success.buttons.viewMoreJobs') }}
                    </button>
                </div>
            </div>
        </div>

        <HomeFooter />
    </div>
</template>

<script>
import HomeHeader from '@/components/HomeHeader.vue';
import HomeFooter from '@/components/HomeFooter.vue';
import ScrollReveal from '@/components/ScrollReveal.vue';
import { useJobsStore } from '@/composables/useJobsStore.js'
import { useWorkWithUsTranslation } from '@/composables/useWorkWithUsTranslation.js';
import API_CONFIG from '@/config/api.js';
import DOMPurify from 'dompurify';

export default {
    name: 'TrabalheConosco',
    components: {
        HomeHeader,
        HomeFooter,
        ScrollReveal
    },
    setup() {
        const { jobsStore, loadJobs } = useJobsStore()
        const { t, currentLanguage } = useWorkWithUsTranslation()

        return {
            jobsStore,
            loadJobsFromStore: loadJobs,
            t,
            currentLanguage
        }
    },
    data() {
        return {
            showForm: false,
            selectedJob: null,
            selectedJobTitle: '',
            isApplicationSubmission: false,
            loadingJobs: true,
            availableJobs: [],
            isSubmitting: false,
            expandedSections: {},
            showSuccessModal: false,
            successTitle: '',
            successMessage: '',
            formData: {
                name: '',
                email: '',
                phone: '',
                position: '',
                education: '',
                experience: '',
                resume: null,
                message: '',
                expectations: '',
                privacy: false
            },
            errors: {}
        };
    },
    async mounted() {
        this.loadingJobs = true

        // Usar vagas do store global
        const jobs = await this.loadJobsFromStore()
        this.availableJobs = jobs
        this.loadingJobs = false

        // Expor métodos de debug no console
        window.trabalheConoscoDebug = {
            testApplicationModal: this.testApplicationModal.bind(this),
            testTalentBankModal: this.testTalentBankModal.bind(this)
        }
        console.log('✅ Debug methods available: window.trabalheConoscoDebug.testApplicationModal() / testTalentBankModal()')

        // Prevenir fechar modal com ESC
        window.addEventListener('keydown', this.handleEscapeKey)
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this.handleEscapeKey)
    },
    methods: {
         // Sanitiza e preserva a formatação (negrito, listas, alinhamento etc.) definida no editor de vagas
         sanitizeHtml(html) {
             if (!html) return '';
             return DOMPurify.sanitize(html);
         },

         // Prevenir fechar modal com ESC quando está aberto
         handleEscapeKey(event) {
             if (event.key === 'Escape' && this.showSuccessModal) {
                 event.preventDefault();
             }
         },

         // Método para alternar seções expandidas
         toggleSection(sectionId) {
            const currentState = this.expandedSections[sectionId] || false;
            this.expandedSections = {
                ...this.expandedSections,
                [sectionId]: !currentState
            };
        },
        // Carregar vagas do backend
        async loadJobs() {
            this.loadingJobs = true;
            try {
                console.log('🔍 Carregando vagas de:', `${API_CONFIG.BASE_URL}/api/jobs`);

                const response = await fetch(`${API_CONFIG.BASE_URL}/api/jobs`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json'
                    }
                });

                console.log('📡 Status da resposta:', response.status);

                if (response.ok) {
                    const jobs = await response.json();
                    console.log('✅ Vagas recebidas:', jobs);

                    this.availableJobs = jobs;

                    if (jobs.length === 0) {
                        console.log('📋 Nenhuma vaga cadastrada no sistema');
                    }
                } else {
                    const errorText = await response.text();
                    console.error('❌ Erro HTTP:', response.status, errorText);
                    throw new Error(`HTTP ${response.status}: ${errorText}`);
                }
            } catch (error) {
                console.error('❌ Erro ao carregar vagas:', error);

                // Mostrar erro específico
                if (error.message.includes('Failed to fetch')) {
                    console.error('🌐 Possível problema de CORS ou rede');
                    alert('Erro de conexão com o servidor. Verifique sua conexão com a internet.');
                } else {
                    alert(`Erro ao carregar vagas: ${error.message}`);
                }

                // Não usar dados simulados - mostrar que não há vagas
                this.availableJobs = [];
            } finally {
                this.loadingJobs = false;
            }
        },

        // Selecionar vaga e mostrar formulário
        selectJob(job) {
            this.selectedJob = job;
            this.showForm = true;
            this.formData.position = job.title; // Preencher automaticamente
            this.$nextTick(() => {
                document.querySelector('.form-section').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        },

        // Mostrar formulário para banco de talentos
        showTalentBankForm() {
            this.selectedJob = null;
            this.showForm = true;
            this.$nextTick(() => {
                document.querySelector('.form-section').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        },

        // Voltar para lista de vagas
        backToJobs() {
            this.showForm = false;
            this.selectedJob = null;
            this.resetForm();
            this.$nextTick(() => {
                document.querySelector('.jobs-section').scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        },

        // Obter ícone baseado no departamento
        getJobIcon(department) {
            const icons = {
                'Administrativo': 'fas fa-clipboard-list',
                'Comercial': 'fas fa-handshake',
                'Estoque': 'fas fa-boxes',
                'Financeiro': 'fas fa-calculator',
                'Fiscal': 'fas fa-file-invoice-dollar',
                'Licitação': 'fas fa-gavel',
                'Logística': 'fas fa-truck',
                'TI': 'fas fa-code',
            };
            return icons[department] || 'fas fa-briefcase';
        },

        // Obter classe do badge baseado no tipo
        getJobBadgeClass(type) {
            const classes = {
                'Jovem Aprendiz': 'badge-apprentice',
                'Estágio': 'badge-internship',
                'CLT': 'badge-clt',
                'PJ': 'badge-pj',
                'Freelancer': 'badge-freelancer'
            };
            return classes[type] || 'badge-default';
        },

        // Formatar telefone
        formatPhone(event) {
            let value = event.target.value.replace(/\D/g, '');
            if (value.length <= 11) {
                value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
                if (value.length < 14) {
                    value = value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
                }
            }
            this.formData.phone = value;
        },

        // Manipular upload de arquivo
        handleFileUpload(event) {
            const file = event.target.files[0];
            if (file) {
                if (file.type !== 'application/pdf') {
                    this.errors.resume = this.t('career.form.validation.pdfOnly');
                    return;
                }
                if (file.size > 5 * 1024 * 1024) { // 5MB
                    this.errors.resume = this.t('career.form.validation.fileSize');
                    return;
                }
                this.formData.resume = file;
                this.errors.resume = '';
            }
        },

        // Validar formulário
        validateForm() {
            console.log('🔍 Validando formulário...');
            this.errors = {};

            if (!this.formData.name.trim()) {
                this.errors.name = this.t('career.form.validation.nameRequired');
            }

            if (!this.formData.email.trim()) {
                this.errors.email = this.t('career.form.validation.emailRequired');
            } else if (!/\S+@\S+\.\S+/.test(this.formData.email)) {
                this.errors.email = this.t('career.form.validation.emailInvalid');
            }

            if (!this.formData.phone.trim()) {
                this.errors.phone = this.t('career.form.validation.phoneRequired');
            }

            if (!this.selectedJob && !this.formData.position) {
                this.errors.position = this.t('career.form.validation.positionRequired');
            }

            if (!this.formData.education) {
                this.errors.education = this.t('career.form.validation.educationRequired');
            }

            if (!this.formData.experience) {
                this.errors.experience = this.t('career.form.validation.experienceRequired');
            }

            if (!this.formData.resume) {
                this.errors.resume = this.t('career.form.validation.resumeRequired');
            }

            if (!this.formData.message.trim()) {
                this.errors.message = this.t('career.form.validation.messageRequired');
            }

            return Object.keys(this.errors).length === 0;
        },

        // Enviar formulário
        async submitForm() {
            console.log('🔄 submitForm chamado');
            console.log('📋 Dados do formulário:', this.formData);
            console.log('🎯 selectedJob:', this.selectedJob);

            if (!this.validateForm()) {
                console.log('❌ Validação falhou:', this.errors);
                return;
            }

            console.log('✅ Validação passou, enviando formulário...');

            this.isSubmitting = true;

            try {
                const formData = new FormData();

                // Adicionar dados do formulário
                Object.keys(this.formData).forEach(key => {
                    if (key !== 'resume') {
                        formData.append(key, this.formData[key]);
                    }
                });

                // Adicionar arquivo
                if (this.formData.resume) {
                    formData.append('resume', this.formData.resume);
                }

                // Guardar informação se é application ou talent bank ANTES de adicionar ao FormData
                const isApplication = !!this.selectedJob;
                console.log('📌 isApplication:', isApplication);

                // Adicionar informações da vaga se selecionada
                if (this.selectedJob) {
                    formData.append('jobId', this.selectedJob.id);
                    formData.append('jobTitle', this.selectedJob.title);
                    console.log('💼 Enviando como Application - Job:', this.selectedJob.title);
                } else {
                    console.log('🏢 Enviando como Talent Bank');
                }

                // Tentar enviar para o backend real primeiro
                const response = await fetch(`${API_CONFIG.BASE_URL}/api/job-applications`, {
                    method: 'POST',
                    body: formData
                });

                if (response.ok) {
                    const result = await response.json();

                    console.log('📊 isApplication antes do modal:', isApplication);

                    // Guardar estado de isApplication e título da vaga ANTES de resetar
                    this.isApplicationSubmission = isApplication;
                    this.selectedJobTitle = isApplication && this.selectedJob ? this.selectedJob.title : '';
                    console.log('🔖 isApplicationSubmission setado para:', this.isApplicationSubmission);
                    console.log('💼 selectedJobTitle setado para:', this.selectedJobTitle);

                    this.showSuccessModal = true;
                    console.log('✅ Modal aberto - isApplicationSubmission:', this.isApplicationSubmission);
                    
                    // Resetar formulário e voltar DEPOIS
                    this.resetForm();
                    this.backToJobs();

                    console.log('✅ Candidatura enviada via API:', result);
                } else {
                    const error = await response.json();
                    throw new Error(error.error || 'Erro ao enviar candidatura');
                }

            } catch (error) {
                console.error('❌ Erro ao enviar candidatura:', error);

                // Mensagem de erro mais específica
                let errorMessage = this.t('career.form.errors.submitError');

                if (error.message.includes('Failed to fetch')) {
                    errorMessage += this.t('career.form.errors.connectionError');
                } else if (error.message.includes('PDF')) {
                    errorMessage += this.t('career.form.errors.pdfError');
                } else {
                    errorMessage += error.message || this.t('career.form.errors.genericError');
                }

                alert(errorMessage);
            } finally {
                this.isSubmitting = false;
            }
        },

        // Fechar modal de sucesso
        closeSuccessModal() {
            this.showSuccessModal = false;
            this.isApplicationSubmission = false;
            this.selectedJobTitle = '';
            this.resetForm();
            this.backToJobs();
        },

        // Ver mais vagas
        viewMoreJobs() {
            this.showSuccessModal = false;
            this.isApplicationSubmission = false;
            this.selectedJobTitle = '';
            this.resetForm();
            this.backToJobs();
        },

        // Resetar formulário
        resetForm() {
            this.formData = {
                name: '',
                email: '',
                phone: '',
                position: '',
                education: '',
                experience: '',
                resume: null,
                message: '',
                expectations: '',
                privacy: false
            };
            this.errors = {};
            if (this.$refs.resumeFile) {
                this.$refs.resumeFile.value = '';
            }
        },
        testApplicationModal() {
            this.selectedJob = { id: 1, title: 'Teste Job' };
            this.successTitle = this.t('career.success.applicationTitle');
            this.successMessage = this.t('career.success.applicationMessage');
            this.showSuccessModal = true;
            console.log('✅ Modal de Application aberto via debug');
        },
        testTalentBankModal() {
            this.selectedJob = null;
            this.successTitle = this.t('career.success.talentBankTitle');
            this.successMessage = this.t('career.success.talentBankMessage');
            this.showSuccessModal = true;
            console.log('✅ Modal de Talent Bank aberto via debug');
        }
    }
};
</script>

<style scoped>
/* Estilos Gerais */
.trabalhe-page {
    font-family: 'Matter', 'Segoe UI', Arial, sans-serif;
    color: #333;
    line-height: 1.6;
    overflow-x: hidden;
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
}

section {
    padding: 80px 0;
}

/* Hero Section com Parallax */
.hero-section {
    position: relative;
    height: 85.3vh;
    min-height: 500px;
    overflow: hidden;
    border-bottom: 4px solid #931414;
}

.parallax-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('@/assets/header-trabalhe-conosco.png');
    background-size: cover;
    background-position: center 26%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: white;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* Mais leve à esquerda (onde a foto já traz o texto/elementos em vermelho,
       pra eles ficarem em destaque, nítidos) e mais forte à direita (área só
       de foto, sem texto, pode escurecer mais sem perder nada) */
    background: linear-gradient(90deg, rgba(71, 4, 4, 0.12) 0%, rgba(147, 20, 20, 0.25) 35%, rgba(147, 20, 20, 0.55) 65%, rgba(0, 0, 0, 0.72) 100%);
}

.hero-title {
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 20px;
    position: relative;
    top: 60px;
    z-index: 2;
    text-transform: uppercase;
    letter-spacing: 2px;
    animation: fadeInUp 1.5s ease-out;
}

.hero-subtitle {
    font-size: 1.5rem;
    font-weight: 300;
    position: relative;
    top: 60px;
    z-index: 2;
    animation: fadeInUp 1.5s ease-out 0.3s both;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(40px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Seção de Introdução */
.intro-section {
    background-color: #f0f0f0;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.intro-section .container {
    position: relative;
    z-index: 1;
}

.section-title {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 40px;
}

.section-title h2 {
    font-size: 2.5rem;
    font-weight: 700;
    color: #931414;
    margin: 0 20px;
}

.section-title.light h2 {
    color: #ffffff;
}

.accent-line {
    height: 3px;
    width: 70px;
    background-color: #931414;
}

.section-title.light .accent-line {
    background-color: #ffffff;
}

.intro-text {
    font-size: 1.3rem;
    max-width: 800px;
    margin: 0 auto;
    color: #555;
    line-height: 1.8;
}

.intro-text-two {
    font-size: 1.3rem;
    max-width: 800px;
    margin: 0 auto;
    color: #555;
    line-height: 1.8;
    margin-top: 20px;
}

/* Seção de Valores */
.values-section {
    background: linear-gradient(90deg, #ffffff, #f0f0f0);
    position: relative;
    padding: 60px 0;
    margin-bottom: 100px;
    overflow: hidden;
}

/* Símbolo em bordô sangrando pelo canto inferior esquerdo (diagonal) */
.values-section::after {
    content: '';
    position: absolute;
    bottom: -399px;
    left: -357px;
    width: 1050px;
    height: 1050px;
    background-image: url('@/assets/uni-simbolo-outline.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    mask-image: linear-gradient(45deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
    -webkit-mask-image: linear-gradient(45deg, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
    pointer-events: none;
    opacity: 0.15;
    z-index: 0;
}

.values-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: repeating-linear-gradient(45deg, rgba(240, 240, 240, 0.07) 0px, rgba(240, 240, 240, 0.07) 1px, transparent 1px, transparent 14px);
    opacity: 0.05;
    z-index: 0;
}

/* Grid responsivo */
.values-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    gap: 100px;
    position: relative;
    z-index: 1;
}

/* Card de valor */
.value-card {
    background: #f0f0f0;
    border-radius: 15px;
    padding: 30px;
    text-align: center;
    border: 1px solid rgba(147, 20, 20, 0.068);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 100%;
}

.value-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
}

/* Ícone dentro do card */
.value-icon {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #931414, #470404);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 20px;
    color: white;
    font-size: 2rem;
}

/* Título do valor */
.value-card h3 {
    font-size: 1.5rem;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #300303, #931414);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Texto do card */
.value-card p {
    color: #696969;
    font-size: 0.95rem;
    line-height: 1.6;
}

/* Seção de Mulheres */
.women-section {
    background: linear-gradient(135deg, #f0f4f8 0%, #f8fafb 100%);
    padding: 100px 0;
    position: relative;
    overflow: hidden;
}

.women-decorative-elements {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    pointer-events: none;
}

.floating-shape {
    position: absolute;
    opacity: 0.05;
    animation: float 6s ease-in-out infinite;
    will-change: transform;
}

.shape-1 {
    width: 300px;
    height: 300px;
    background: #931414;
    border-radius: 40% 60% 70% 30% / 40% 50% 60% 50%;
    top: 10%;
    right: 5%;
}

.shape-2 {
    width: 250px;
    height: 250px;
    background: #470404;
    border-radius: 60% 40% 30% 70% / 60% 30% 70% 40%;
    top: 60%;
    left: 5%;
    animation-delay: 2s;
}

.shape-3 {
    width: 200px;
    height: 200px;
    background: #931414;
    border-radius: 50% 50% 50% 0;
    bottom: 5%;
    right: 15%;
    animation-delay: 4s;
}

@keyframes float {
    50% {
        transform: translateY(20px) rotate(5deg);
    }
}

.geometric-element {
    position: absolute;
    opacity: 0.08;
    animation: rotate-geo 15s linear infinite;
    will-change: transform;
}

.geo-1 {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #931414, #470404);
    border-radius: 0 50% 50% 50%;
    top: 15%;
    right: 20%;
    animation-delay: 0s;
}

.geo-2 {
    width: 100px;
    height: 100px;
    background: #931414;
    clip-path: polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%);
    bottom: 25%;
    left: 10%;
    animation-delay: 3s;
}

.geo-3 {
    width: 60px;
    height: 60px;
    background: linear-gradient(45deg, #470404, #931414);
    border-radius: 50%;
    top: 40%;
    left: 5%;
    animation-delay: 1.5s;
}

.geo-4 {
    width: 90px;
    height: 90px;
    background: #931414;
    clip-path: polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%);
    bottom: 10%;
    right: 5%;
    animation-delay: 2s;
}

@keyframes rotate-geo {
    to {
        transform: rotate(360deg);
    }
}

.line-element {
    position: absolute;
    background: linear-gradient(90deg, transparent, rgba(147, 20, 20, 0.15), transparent);
    opacity: 0.6;
    animation: slide-line 8s linear infinite;
    will-change: transform;
}

.line-1 {
    width: 200px;
    height: 2px;
    top: 30%;
    left: 0;
}

.line-2 {
    width: 250px;
    height: 2px;
    bottom: 40%;
    right: 0;
    animation-delay: 2s;
}

@keyframes slide-line {
    0% {
        transform: translateX(-500px);
    }

    100% {
        transform: translateX(calc(100vw + 250px));
    }
}

.women-header {
    position: relative;
    z-index: 1;
    text-align: center;
    margin-bottom: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Elementos decorativos do header */
.header-decoration-elements {
    position: absolute;
    top: -20px;
    left: -30px;
    width: 150px;
    height: 150px;
    pointer-events: none;
    z-index: 0;
}

.deco-circle {
    position: absolute;
    border-radius: 50%;
    opacity: 0.15;
    animation: float 6s ease-in-out infinite;
}

.deco-1 {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #931414, #470404);
    top: 0;
    left: 0;
    animation-delay: 0s;
}

.deco-2 {
    width: 55px;
    height: 55px;
    background: #470404;
    top: 35px;
    left: 50px;
    animation-delay: 1s;
}

.deco-line {
    position: absolute;
    background: linear-gradient(90deg, #931414, transparent);
    opacity: 0.2;
    animation: slide-line 8s linear infinite;
}

.deco-line-1 {
    width: 120px;
    height: 2px;
    top: 40px;
    left: 0;
    animation-delay: 0s;
}

.deco-line-2 {
    width: 100px;
    height: 2px;
    top: 80px;
    left: 20px;
    animation-delay: 1s;
}

.women-stats {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 40px;
    margin: 40px 0 30px;
    flex-wrap: wrap;
}

.stat-item {
    text-align: center;
    animation: slideUp 0.8s ease-out;
    position: relative;
}

.stat-item:hover .stat-number {
    animation: number-pulse 0.6s ease;
}

.stat-number {
    font-size: 3.5rem;
    font-weight: 800;
    background: linear-gradient(135deg, #931414, #470404);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1;
    margin-bottom: 8px;
    transition: all 0.3s ease;
}

.stat-item:hover .stat-number {
    font-size: 3.8rem;
    filter: drop-shadow(0 4px 12px rgba(147, 20, 20, 0.3));
}

@keyframes number-pulse {

    0%,
    100% {
        transform: scale(1);
    }

    50% {
        transform: scale(1.05);
    }
}

.stat-label {
    font-size: 1rem;
    color: #555;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.stat-divider {
    width: 2px;
    height: 60px;
    background: linear-gradient(180deg, rgba(147, 20, 20, 0), #931414, rgba(147, 20, 20, 0));
}

.women-description {
    font-size: 1.1rem;
    color: #555;
    line-height: 1.8;
    max-width: 750px;
    margin: 0 auto;
}

.women-staircase-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 40px;
    position: relative;
    z-index: 2;
    max-width: 1200px;
    margin: 0 auto;
}

.staircase-item {
    display: flex;
    position: relative;
    animation: staircase-appear 0.8s ease-out backwards;
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
}

.staircase-item.left-side {
    justify-content: flex-end;
    animation-name: slide-in-left;
}

.staircase-item.right-side {
    justify-content: flex-start;
    animation-name: slide-in-right;
}

.staircase-item.left-side:nth-child(1) {
    animation-delay: 0.3s;
}

.staircase-item.right-side:nth-child(2) {
    animation-delay: 0.5s;
}

.staircase-item.left-side:nth-child(3) {
    animation-delay: 0.7s;
}

.staircase-item.right-side:nth-child(4) {
    animation-delay: 0.9s;
}

@keyframes slide-in-left {
    from {
        opacity: 0;
        transform: translateX(-60px) translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateX(0) translateY(0);
    }
}

@keyframes slide-in-right {
    from {
        opacity: 0;
        transform: translateX(60px) translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateX(0) translateY(0);
    }
}

@keyframes staircase-appear {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.women-floating-illustration {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 0;
    pointer-events: none;
    overflow: hidden;
    will-change: auto;
}

.illustration {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.illustration-item {
    position: absolute;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 2.5rem;
    animation: float-item 5s ease-in-out infinite;
    filter: drop-shadow(0 5px 15px rgba(147, 20, 20, 0.2));
    will-change: transform;
}

@media (max-width: 480px) {
    .illustration-item {
        width: 50px !important;
        height: 50px !important;
        font-size: 1.5rem !important;
    }
}

.illustration-item.item-1 {
    background: linear-gradient(135deg, #931414, #470404);
    top: 15%;
    left: 8%;
    animation-delay: 0s;
}

.illustration-item.item-2 {
    background: linear-gradient(135deg, #470404, #931414);
    bottom: 15%;
    right: 5%;
    animation-delay: 0.7s;
}

.illustration-item.item-3 {
    background: linear-gradient(135deg, #931414, #470404);
    top: 50%;
    right: 10%;
    animation-delay: 1.4s;
}

.illustration-item.item-4 {
    background: linear-gradient(135deg, #470404, #931414);
    bottom: 35%;
    left: 5%;
    animation-delay: 2.1s;
}

@keyframes float-item {
    25% {
        transform: translateY(-20px) scale(1.08) rotate(5deg);
    }

    50% {
        transform: translateY(-10px) scale(1.05) rotate(-2deg);
    }

    75% {
        transform: translateY(-15px) scale(1.08) rotate(3deg);
    }
}

.highlight-card {
    background: linear-gradient(135deg, #ffffff 0%, #f9f7f5 100%);
    padding: 30px;
    border-radius: 15px;
    text-align: left;
    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.08);
    position: relative;
    overflow: visible;
    clip-path: inset(0 0 0 0 round 15px);
    border: 1px solid rgba(147, 20, 20, 0.12);
    border-left: 5px solid #931414;
    min-width: 280px;
    min-height: 330px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    box-sizing: border-box;
}

.highlight-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.04), rgba(184, 48, 48, 0.03));
    pointer-events: none;
    border-radius: 15px;
}

.highlight-card::after {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s ease;
    pointer-events: none;
}

.highlight-card:hover::after {
    left: 100%;
}

.highlight-card:hover {
    transform: translateX(10px) translateY(-5px);
    box-shadow: 0 20px 40px rgba(147, 20, 20, 0.2);
    border-left-color: #470404;
}

.card-badge {
    display: inline-block;
    background: linear-gradient(135deg, #931414, #470404);
    color: white;
    padding: 5px 12px;
    border-radius: 18px;
    font-size: 0.75rem;
    font-weight: 700;
    margin-bottom: 12px;
    letter-spacing: 0.3px;
    position: relative;
    overflow: hidden;
    transition: all 0.3s ease;
    align-self: center;
}

.card-badge::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.3);
    transition: left 0.4s ease;
}

.highlight-card:hover .card-badge {
    transform: scale(1.1);
    box-shadow: 0 4px 12px rgba(147, 20, 20, 0.3);
}

.highlight-card:hover .card-badge::before {
    left: 100%;
}

.highlight-icon {
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
    background: linear-gradient(135deg, #931414, #470404);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.8rem;
    transition: all 0.4s ease;
    position: relative;
    overflow: hidden;
}

.highlight-icon::before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    animation: shine 3s infinite;
}

@keyframes shine {
    0% {
        transform: rotate(0deg) translateX(-100%);
    }

    100% {
        transform: rotate(0deg) translateX(100%);
    }
}

.highlight-card:hover .highlight-icon {
    transform: scale(1.15) rotate(-5deg);
    box-shadow: 0 10px 25px rgba(147, 20, 20, 0.3);
    animation: bounce-icon 0.6s ease;
}

@keyframes bounce-icon {

    0%,
    100% {
        transform: scale(1.15) rotate(-5deg);
    }

    50% {
        transform: scale(1.2) rotate(-5deg);
    }
}

.highlight-card h3 {
    font-size: 1.2rem;
    font-weight: 700;
    background: linear-gradient(-135deg, #300303, #931414);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0 0 10px;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.highlight-card:hover h3 {
    color: #931414;
    transform: translateX(5px);
}

.highlight-card p {
    font-size: 0.9rem;
    color: #666;
    line-height: 1.6;
    margin: 0;
    position: relative;
    z-index: 1;
    transition: all 0.3s ease;
    flex-grow: 1;
    overflow: hidden;
}

.highlight-card:hover p {
    color: #555;
    transform: translateX(3px);
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Seção de Benefícios */
.benefits-section {
    background: linear-gradient(135deg, #931414, #470404);
    color: white;
    position: relative;
    overflow: hidden;
}

/* Símbolo em branco centralizado no topo, desvanecendo pras laterais */
.benefits-section::after {
    content: '';
    position: absolute;
    top: -462px;
    left: 50%;
    transform: translateX(-50%);
    width: 1176px;
    height: 1176px;
    background-image: url('@/assets/uni-simbolo-outline-branco.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 75%);
    -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.4) 50%, transparent 75%);
    pointer-events: none;
    opacity: 0.12;
    z-index: 0;
}

.benefits-section::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.08) 0px, rgba(255, 255, 255, 0.08) 1px, transparent 1px, transparent 14px);
}

.benefits-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    align-items: center;
    position: relative;
    z-index: 1;
}

.benefits-image {
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
}

.benefits-image img {
    width: 100%;
    height: auto;
    display: block;
    transition: transform 0.5s ease;
}

.benefits-image:hover img {
    transform: scale(1.05);
}

.benefits-list {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

.benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(5px);
    padding: 20px;
    border-radius: 10px;
    transition: transform 0.3s ease, background-color 0.3s ease;
}

.benefit-item:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.2);
}

.benefit-icon {
    width: 50px;
    height: 50px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.5rem;
    color: white;
    flex-shrink: 0;
}

.benefit-content {
    flex: 1;
}

.benefit-content h4 {
    font-size: 1.2rem;
    margin-bottom: 10px;
    margin-top: 0;
    color: white;
}

.benefit-content p {
    color: rgba(255, 255, 255, 0.9);
    margin: 0;
}

/* Novos estilos para seção de vagas */
.jobs-section {
    padding: 80px 0;
    background: linear-gradient(135deg, #f0f0f0 0%, #ffffff 100%);
    position: relative;
    overflow: hidden;
}

/* Símbolo da marca único, sangrando pela lateral direita */
.watermark-side {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 1008px;
    height: 1008px;
    background-image: url('@/assets/uni-simbolo-outline.svg');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    opacity: 0.16;
    pointer-events: none;
    z-index: 0;
}

.watermark-side-right {
    right: -399px;
    mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
    -webkit-mask-image: linear-gradient(to left, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
}

.watermark-side-left {
    left: -399px;
    mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
    -webkit-mask-image: linear-gradient(to right, rgba(0, 0, 0, 1) 0%, rgba(0, 0, 0, 0.5) 55%, transparent 85%);
}

.jobs-section .container {
    position: relative;
    z-index: 1;
}

.jobs-intro {
    text-align: center;
    font-size: 1.1rem;
    color: #696969;
    margin-bottom: 50px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
}

.loading-container {
    text-align: center;
    padding: 60px 20px;
}

.loading-spinner {
    font-size: 3rem;
    color: #931414;
    margin-bottom: 20px;
}

.jobs-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(440px, 1fr));
    gap: 60px;
    margin-top: 40px;
}

.job-card {
    background: white;
    border-radius: 15px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
    transition: all 0.3s ease;
    cursor: pointer;
    border: 2px solid transparent;
    position: relative;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 650px;
    max-width: 700px;
    text-align: left;
    margin: 0 auto;
}

.job-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(147, 20, 20, 0.05), transparent);
    transition: left 0.5s ease;
}

.job-card:hover::before {
    left: 100%;
}

.job-card:hover {
    transform: translateY(-10px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.15);
    border-color: #931414;
}

.job-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 25px 25px 0;
    margin-bottom: 20px;
}

.job-content {
    position: relative;
    z-index: 1;
    flex: 1;
    padding: 20px 25px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    text-align: left;
    width: 100%;
    box-sizing: border-box;
    overflow: hidden;
}

.job-content>* {
    max-width: 100%;
    box-sizing: border-box;
}

.job-content>*:not(:last-child) {
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: none;
}

.job-title {
    font-size: 1.3rem;
    font-weight: 700;
    color: #931414;
    margin: 0 0 5px 0;
    line-height: 1.4;
    min-height: auto;
    display: block;
    text-align: left;
}

.job-info {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    padding: 16px;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.03) 0%, rgba(147, 20, 20, 0.01) 100%);
    border-radius: 12px;
    border-left: 4px solid #931414;
    align-items: start;
    text-align: left;
    box-shadow: 0 2px 8px rgba(147, 20, 20, 0.06);
}

.job-detail {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 0.9rem;
    color: #555;
    padding: 4px 0;
}

.job-detail i {
    color: #931414;
    width: 18px;
    flex-shrink: 0;
    text-align: center;
    font-size: 0.95rem;
}

.job-description-section {
    text-align: center;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.04) 0%, rgba(147, 20, 20, 0.01) 100%);
    padding: 16px;
    border-radius: 12px;
    border-left: 4px solid rgba(147, 20, 20, 0.4);
    width: 100%;
    box-sizing: border-box;
    min-height: auto;
    height: auto;
}

.job-description-section h4 {
    font-size: 0.95rem;
    color: #931414;
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
}

.job-description-section h4::before {
    content: '📋';
    font-size: 0.85rem;
}

.job-description {
    color: #555;
    line-height: 1.6;
    margin: 0;
    font-size: 0.9rem;
    text-align: center;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    white-space: pre-wrap;
    max-width: 100%;
}

.short-description {
    width: 100%;
    overflow: hidden;
}

.complete-description {
    margin-top: 16px;
    padding: 16px;
    border: none;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.05) 0%, rgba(147, 20, 20, 0.02) 100%);
    border-radius: 12px;
    border-left: 4px solid #931414;
    animation: fadeIn 0.3s ease-in-out;
    width: 94%;
    min-height: auto;
    height: auto;
}

.complete-description-title {
    font-size: 1rem;
    color: white;
    background: linear-gradient(135deg, #931414, #470404);
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 8px 12px;
    border-radius: 8px;
    text-align: center;
}

.complete-description-title::before {
    content: '→';
    font-size: 1rem;
}

.job-description-complete {
    color: #555;
    line-height: 1.6;
    margin: 0;
    font-size: 0.9rem;
    text-align: left;
    background: transparent;
    padding: 0;
    border-radius: 0;
    border-left: none;
    word-wrap: break-word;
    overflow-wrap: break-word;
    hyphens: auto;
    white-space: pre-wrap;
    text-align: center;
    max-width: 100%;
    box-sizing: border-box;
    min-height: auto;
    height: auto;
}

/* Animação para expansão */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(-10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.job-description-section .expand-button {
    background: transparent;
    border: 1px solid #931414;
    color: #931414;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 0.85rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin: 15px auto 0;
    font-weight: 500;
    max-width: fit-content;
    margin-bottom: 10px;
}

.job-description-section .expand-button:hover {
    background: #931414;
    color: white;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(147, 20, 20, 0.3);
}

/* Estilos para conteúdo expandível */
.expandable-content {
    position: relative;
}

.job-description.expanded {
    -webkit-line-clamp: unset;
    line-clamp: unset;
    overflow: visible;
    display: block;
}

.expand-button {
    background: transparent;
    border: 1px solid #931414;
    color: #931414;
    padding: 6px 12px;
    border-radius: 15px;
    font-size: 0.8rem;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
    margin: 10px auto 0;
    font-weight: 500;
    margin-bottom: 10px;
}

.expand-button:hover {
    background: #931414;
    color: white;
    transform: translateY(-1px);
}

.expand-button i {
    font-size: 0.7rem;
    transition: transform 0.3s ease;
}

.job-requirements h4 {
    font-size: 1rem;
    color: #333;
    margin: 0 0 10px 0;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
}

.job-requirements h4::before {
    content: '◆';
    font-size: 0.9rem;
}

/* Listas de requisitos e benefícios */
.requirements-list,
.additional-requirements-list,
.benefits-list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.requirements-list li,
.additional-requirements-list li,
.benefits-list li {
    position: relative;
    padding-left: 20px;
    font-size: 0.9rem;
    color: #696969;
    line-height: 1.4;
}

.requirements-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #931414;
    font-weight: bold;
}

.additional-requirements-list li::before {
    content: '◦';
    position: absolute;
    left: 0;
    color: #931414;
    font-weight: bold;
}

.benefits-list li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #28a745;
    font-weight: bold;
}

/* Seções de requisitos adicionais */
.job-additional-requirements h4 {
    font-size: 0.95rem;
    color: #931414;
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
}

.job-additional-requirements h4::before {
    content: '+';
    font-size: 1.1rem;
    font-weight: bold;
}

.requirements-list li::before {
    content: '•';
    position: absolute;
    left: 0;
    color: #931414;
    font-weight: bold;
}

.benefits-list li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #28a745;
    font-weight: bold;
}

.more-requirements,
.more-benefits {
    font-style: italic;
    color: #888 !important;
    font-size: 0.85rem !important;
}

.more-requirements::before,
.more-benefits::before {
    content: '⋯';
    color: #931414 !important;
}

.job-benefits-preview {
    background: linear-gradient(135deg, rgba(40, 167, 69, 0.04) 0%, rgba(40, 167, 69, 0.01) 100%);
    padding: 16px;
    border-radius: 12px;
    border-left: 4px solid rgba(40, 167, 69, 0.4);
}

.job-benefits-preview .benefits-list {
    align-items: flex-start;
}

.job-benefits-preview .benefits-list li {
    text-align: left;
}

.job-benefits-preview h4 {
    font-size: 0.95rem;
    color: #28a745;
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    text-align: center;
}

.job-benefits-preview h4::before {
    content: '★';
    font-size: 1rem;
}

.job-footer {
    padding: 20px 25px 25px;
    margin-top: 20px;
    position: relative;
    z-index: 1;
    border-top: 1px solid #f0f0f0;
}

/* .apply-button está na regra global de glass (public/styles.css),
   mas o fundo aqui (.job-footer) é branco chapado, então precisa de
   opacidade alta pra não ficar sujo/desbotado */
.apply-button {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.32), rgba(71, 4, 4, 0.32)) !important;
    backdrop-filter: blur(20px) saturate(200%) !important;
    -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
    padding: 12px 24px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 0.9rem;
    width: 100%;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.apply-button::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 60%);
    pointer-events: none;
}

.apply-button i {
    position: relative;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
}

.apply-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(147, 20, 20, 0.4);
}

.job-icon {
    width: 50px;
    height: 50px;
    background: linear-gradient(135deg, #931414, #470404);
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.5rem;
}

.job-badge {
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 0.8rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.badge-apprentice {
    background: linear-gradient(135deg, #17a2b8, #0dcaf0);
    color: white;
}

.badge-internship {
    background: linear-gradient(135deg, #ffc107, #fd7e14);
    color: white;
}

.badge-clt {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
}

.badge-pj {
    background: linear-gradient(135deg, #007bff, #6610f2);
    color: white;
}

.badge-freelancer {
    background: linear-gradient(135deg, #6f42c1, #e83e8c);
    color: white;
}

.badge-default {
    background: linear-gradient(135deg, #6c757d, #495057);
    color: white;
}

.job-requirements {
    margin-bottom: 20px;
    text-align: left;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.04) 0%, rgba(147, 20, 20, 0.01) 100%);
    padding: 16px;
    border-radius: 12px;
    border-left: 4px solid rgba(147, 20, 20, 0.4);
}

.job-requirements h4 {
    font-size: 0.95rem;
    color: #931414;
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}

.job-requirements h4::before {
    content: '◆';
    font-size: 1rem;
}

.job-requirements .requirements-list {
    align-items: flex-start;
}

.job-requirements .requirements-list li {
    text-align: left;
}

.job-additional-requirements {
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.04) 0%, rgba(147, 20, 20, 0.01) 100%);
    padding: 16px;
    border-radius: 12px;
    border-left: 4px solid rgba(147, 20, 20, 0.4);
}

.job-additional-requirements .additional-requirements-list {
    align-items: flex-start;
    padding-bottom: 16px;
}

.job-additional-requirements .additional-requirements-list li {
    text-align: left;
}

.job-requirements ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.job-requirements li {
    position: relative;
    padding-left: 24px;
    margin-bottom: 8px;
    font-size: 0.9rem;
    color: #555;
    line-height: 1.5;
}

.job-requirements li::before {
    content: '▸';
    position: absolute;
    left: 0;
    color: #931414;
    font-weight: bold;
}

.additional-requirements,
.job-benefits {
    margin-top: 0;
}

.additional-requirements h4,
.job-benefits h4 {
    font-size: 0.95rem;
    color: #931414;
    margin: 0 0 12px 0;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}

.job-benefits h4 {
    color: #28a745;
}

.additional-requirements h4::before {
    content: '◦';
    font-size: 1rem;
}

.job-benefits h4::before {
    content: '★';
    font-size: 1rem;
}

.additional-requirements ul,
.job-benefits ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.additional-requirements li,
.job-benefits li {
    position: relative;
    padding-left: 24px;
    margin-bottom: 8px;
    font-size: 0.9rem;
    color: #555;
    line-height: 1.5;
}

.additional-requirements li::before {
    content: '◦';
    position: absolute;
    left: 0;
    color: #931414;
    font-weight: bold;
}

.job-benefits li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #28a745;
    font-weight: bold;
}

.job-salary {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #28a745;
    font-size: 1rem;
}

.job-salary i {
    color: #28a745;
}

.no-jobs-container {
    text-align: center;
    padding: 80px 20px;
}

.no-jobs-content {
    max-width: 500px;
    margin: 0 auto;
}

.no-jobs-icon {
    font-size: 4rem;
    color: #931414;
    margin-bottom: 30px;
}

.no-jobs-content h3 {
    font-size: 1.8rem;
    background: linear-gradient(135deg, #300303, #931414);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 20px;
}

.no-jobs-content p {
    color: #696969;
    line-height: 1.6;
    margin-bottom: 30px;
}

/* .talent-bank-button está na regra global de glass, mas o fundo aqui
   (.no-jobs-content) é claro chapado, então precisa de opacidade alta
   pra não ficar sujo/desbotado */
.talent-bank-button {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.32), rgba(71, 4, 4, 0.32)) !important;
    backdrop-filter: blur(20px) saturate(200%) !important;
    -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
    padding: 15px 30px;
    border-radius: 30px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 1rem;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.talent-bank-button::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 60%);
    pointer-events: none;
}

.talent-bank-button i {
    position: relative;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
}

.talent-bank-button:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(147, 20, 20, 0.4);
}

/* Estilos para formulário */
.form-section {
    padding: 80px 0;
    background: linear-gradient(135deg, #ffffff 0%, #f0f0f0 100%);
}

.selected-job-info {
    background: white;
    border-radius: 15px;
    padding: 25px;
    margin-bottom: 40px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    border-left: 4px solid #931414;
}

.job-summary-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;
}

.job-summary-header h3 {
    color: #931414;
    font-size: 1.3rem;
    margin: 0;
}

/* .back-button está na regra global de glass, que forçaria um
   preenchimento vermelho sólido nesse botão fantasma (outline). Aqui
   se restaura o estilo outline original com um leve glass translúcido. */
.back-button {
    position: relative;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.6) !important;
    backdrop-filter: blur(10px) saturate(180%) !important;
    -webkit-backdrop-filter: blur(10px) saturate(180%) !important;
    border: 2px solid #931414 !important;
    color: #931414 !important;
    -webkit-text-fill-color: #931414 !important;
    padding: 8px 16px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 0.9rem;
}

.back-button i {
    position: relative;
    background-image: none !important;
    -webkit-background-clip: initial !important;
    background-clip: initial !important;
    -webkit-text-fill-color: #931414 !important;
    color: #931414 !important;
}

.back-button:hover {
    background: #931414 !important;
    color: white !important;
    -webkit-text-fill-color: #ffffff !important;
  text-shadow: 0 1px 3px rgba(42, 3, 3, 0.55), 0 1px 8px rgba(42, 3, 3, 0.35);
}

.back-button:hover i {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff !important;
}

.job-summary-details {
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.job-summary-details span {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #696969;
    font-size: 0.9rem;
}

.job-summary-details i {
    color: #931414;
}

.form-intro {
    text-align: center;
    color: #696969;
    margin-bottom: 40px;
    font-size: 1.1rem;
    line-height: 1.6;
}

.form-container {
    max-width: 800px;
    margin: 0 auto;
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    overflow: hidden;
}

.form-header {
    background: linear-gradient(135deg, #931414, #470404);
    color: white;
    padding: 30px;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0;
    border-radius: 0;
}

.form-icon {
    font-size: 2.5rem;
    background: rgba(255, 255, 255, 0.2);
    width: 70px;
    height: 70px;
    min-width: 70px;
    min-height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    flex-shrink: 0;
}

.form-header h3 {
    font-size: 1.8rem;
    font-weight: 700;
    margin: 0;
}

.career-form {
    padding: 40px;
    background: white;
}

.form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 25px;
    margin-bottom: 25px;
}

.form-group {
    display: flex;
    flex-direction: column;
}

.form-group.full-width {
    grid-column: 1 / -1;
    margin-top: 20px
}

.form-group label {
    font-weight: 600;
    color: #333;
    margin-bottom: 8px;
    font-size: 0.95rem;
}

.form-group label::after {
    content: ' *';
    color: #dc3545;
    font-weight: bold;
}

/* Remover asterisco de campos opcionais */
.form-group.optional-field label::after {
    content: none;
}

.file-upload-container label::after {
    content: none;
}

.form-group input,
.form-group select,
.form-group textarea {
    padding: 12px 15px;
    border: 2px solid #f0f0f0;
    border-radius: 8px;
    font-size: 1rem;
    transition: all 0.3s ease;
    background: white;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
    outline: none;
    border-color: #931414;
    box-shadow: 0 0 0 3px rgba(147, 20, 20, 0.1);
}

.form-group textarea {
    resize: vertical;
    min-height: 120px;
    font-family: inherit;
}

.file-upload-container {
    position: relative;
}

.file-input {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    left: 0;
}

.file-upload-label {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 15px;
    border: 2px dashed #931414;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(147, 20, 20, 0.05);
    color: #931414;
    font-weight: 500;
    text-align: left;
}

.file-upload-label:hover {
    background: rgba(147, 20, 20, 0.1);
    border-style: solid;
}

.file-upload-label i {
    font-size: 1.2rem;
}

.checkbox-group {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
}

.checkbox-group input[type="checkbox"] {
    margin-top: 4px;
    transform: scale(1.2);
    accent-color: #931414;
    flex-shrink: 0;
    min-width: 16px;
    width: 16px;
    height: 16px;
    align-self: flex-start;
}

.checkbox-group label {
    font-size: 0.8rem;
    line-height: 1.5;
    color: #555;
    margin-bottom: 0;
    flex: 1;
    word-wrap: break-word;
    overflow-wrap: break-word;
    text-align: left;
    margin-top: 0;
    padding-top: 2px;
}

.checkbox-group a {
    color: #931414;
    text-decoration: none;
    word-wrap: break-word;
}

.checkbox-group a:hover {
    text-decoration: underline;
}

.error-message {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 5px;
    font-weight: 500;
}

.file-upload-container+.error-message {
    text-align: left;
    margin-left: 0;
    display: block;
    width: 100%;
}

.form-actions {
    display: flex;
    gap: 15px;
    justify-content: flex-end;
    margin-top: 30px;
    padding-top: 25px;
    border-top: 1px solid #f0f0f0;
}

.cancel-button {
    background: transparent;
    border: 2px solid #6c757d;
    color: #6c757d;
    padding: 12px 24px;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
}

.cancel-button:hover {
    background: #6c757d;
    color: white;
}

/* .submit-button está na regra global de glass, mas o fundo aqui é
   branco chapado, então precisa de opacidade alta pra não ficar
   sujo/desbotado */
.submit-button {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.32), rgba(71, 4, 4, 0.32)) !important;
    backdrop-filter: blur(20px) saturate(200%) !important;
    -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
    padding: 12px 30px;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    font-size: 1rem;
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.3);
}

.submit-button::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 60%);
    pointer-events: none;
}

.submit-button i {
    position: relative;
    background-image: none !important;
    -webkit-background-clip: initial !important;
    background-clip: initial !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(147, 20, 20, 0.4);
}

.submit-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Estilos para o checkbox de termos */
.terms-group {
    margin-bottom: 10px;
    padding: 15px;
    background-color: #f0f0f0;
    border-radius: 8px;
    border-left: 3px solid #931414;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
    text-align: center;
}

.terms-group:hover {
    background-color: #f0f0f0;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
}

.checkbox-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.checkbox-container input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: #931414;
}

.terms-label {
    font-size: 0.95rem;
    color: #555;
    line-height: 1.5;
    font-weight: 500;
    text-align: left;
}

.terms-label a {
    color: #931414;
    text-decoration: none;
    font-weight: 600;
    transition: color 0.3s ease;
    position: relative;
}

.terms-label a:hover {
    color: #470404;
}

.terms-label a::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    bottom: -98px;
    left: 0;
    background-color: #931414;
    transform: scaleX(0);
    transform-origin: bottom right;
    transition: transform 0.3s ease;
}

.terms-label a:hover::after {
    transform: scaleX(1);
    transform-origin: bottom left;
}

/* Aviso de Termos */
.terms-notice {
    margin: 30px 0 20px 0;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.05), rgba(147, 20, 20, 0.02));
    border: 1px solid rgba(147, 20, 20, 0.2);
    border-radius: 10px;
    padding: 20px;
}

.terms-link {
    color: #931414;
    font-weight: 600;
    text-decoration: none;
    transition: color 0.3s ease;
}

.terms-link:hover {
    color: #470404;
    text-decoration: underline;
}

/* .submit-button está na regra global de glass, mas o fundo aqui é
   branco chapado, então precisa de opacidade alta pra não ficar
   sujo/desbotado */
.submit-button {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(147, 20, 20, 0.32), rgba(71, 4, 4, 0.32)) !important;
    backdrop-filter: blur(20px) saturate(200%) !important;
    -webkit-backdrop-filter: blur(20px) saturate(200%) !important;
    border: 1px solid rgba(255, 255, 255, 0.5) !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
    padding: 15px 30px;
    border-radius: 50px;
    font-size: 1.1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    box-shadow: 0 10px 20px rgba(147, 20, 20, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.3);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
}

.submit-button::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, transparent 60%);
    pointer-events: none;
}

.submit-button i {
    position: relative;
    background-image: none !important;
    -webkit-background-clip: initial !important;
    background-clip: initial !important;
        -webkit-text-fill-color: #470404 !important;
    color: #470404 !important;
}

.submit-button:hover:not(:disabled) {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(147, 20, 20, 0.4);
}

.submit-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

/* Seção de FAQ */
.faq-section {
    background: linear-gradient(225deg, #ffffff, #f0f0f0);
}

.faq-container {
    max-width: 800px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.faq-item {
    background: #f0f0f0;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.faq-item:hover {
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
}

.faq-question {
    padding: 20px 25px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    background: white;
}

.faq-question h4 {
    font-size: 1.1rem;
    color: #333;
    margin: 0;
    font-weight: 600;
}

.faq-question i {
    color: #931414;
    font-size: 1rem;
    transition: transform 0.3s ease;
}

.faq-item.active .faq-question i {
    transform: rotate(180deg);
}

.faq-answer {
    padding: 0;
    max-height: 0;
    overflow: hidden;
    transition: all 0.3s ease;
}

.faq-item.active .faq-answer {
    padding: 0 25px 20px;
    max-height: 500px;
}

.faq-answer p {
    color: #696969;
    margin: 0;
}

/* Modal de Sucesso */
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.modal-content {
    background: white;
    border-radius: 15px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 15px 30px rgba(0, 0, 0, 0.2);
    animation: scaleIn 0.3s ease;
}

@keyframes scaleIn {
    from {
        transform: scale(0.9);
        opacity: 0;
    }

    to {
        transform: scale(1);
        opacity: 1;
    }
}

.modal-header {
    padding: 25px;
    text-align: center;
    border-bottom: 1px solid #f0f0f0;
}

.modal-header i {
    font-size: 3rem;
    color: #4CAF50;
    margin-bottom: 15px;
}

.modal-header h3 {
    font-size: 1.5rem;
    color: #333;
    margin: 0;
}

.modal-body {
    padding: 25px;
    text-align: center;
}

.modal-body p {
    color: #696969;
    margin-bottom: 15px;
    line-height: 1.6;
}

.modal-body p:last-child {
    margin-bottom: 0;
}

.modal-footer {
    padding: 15px 25px 25px;
    text-align: center;
}

.modal-button {
    background: linear-gradient(135deg, #931414, #470404);
    color: white;
    border: none;
    padding: 12px 30px;
    border-radius: 50px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.modal-button:hover {
    background: linear-gradient(135deg, #470404, #931414);
    transform: translateY(-3px);
    box-shadow: 0 10px 20px rgba(147, 20, 20, 0.3);
}

:deep(.footer-class) {
    z-index: 999 !important;
}

.privacy-disclaimer {
    margin-top: 10px;
    padding: 12px;
    background-color: #f0f0f0;
    border-radius: 6px;
    border-left: 3px solid #931414;
}

.notice-content {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 8px;
}

.notice-icon {
    color: #931414;
    font-size: 1.1rem;
    margin-top: 2px;
    flex-shrink: 0;
}

.notice-content p {
    margin: 0;
    flex: 1;
}

.privacy-disclaimer p {
    font-size: 0.75rem;
    color: #6c757d;
    line-height: 1.4;
    margin: 0 0 8px 0;
    text-align: left;
}

.privacy-disclaimer p:last-child {
    margin-bottom: 0;
}

.privacy-disclaimer a {
    color: #931414;
    text-decoration: none;
    font-weight: 500;
}

.privacy-disclaimer a:hover {
    text-decoration: underline;
    color: #470404;
}

/* Responsividade */

@media (max-width: 1200px) {
    .container {
        padding: 0 40px;
    }

    .values-grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 992px) {
    .hero-title {
        font-size: 3rem;
    }

    .hero-subtitle {
        font-size: 1.3rem;
    }

    section {
        padding: 60px 0;
    }

    .benefits-container {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .benefits-image {
        order: 2;
    }

    .benefits-list {
        order: 1;
    }

    .form-icon {
        font-size: 2.2rem;
        width: 65px;
        height: 65px;
    }

    .form-header h3 {
        font-size: 1.6rem;
    }
}

@media (max-width: 1200px) {
    .geometric-element {
        opacity: 0.06;
    }

    .geo-1 {
        width: 70px;
        height: 70px;
        right: 15%;
    }

    .geo-2 {
        width: 80px;
        height: 80px;
        left: 8%;
    }

    .geo-3 {
        width: 50px;
        height: 50px;
    }

    .geo-4 {
        width: 75px;
        height: 75px;
    }

    .stat-number {
        font-size: 2.8rem;
    }
}

@media (max-width: 1750px) {
    .illustration-item {
        width: 72px;
        height: 72px;
        opacity: 0.75;
        flex-shrink: 0;
    }

    .illustration-item.item-1 {
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        background: linear-gradient(135deg, #931414, #470404);
        order: 1;
        animation: none;
        margin: 0 5px;
    }

    .illustration-item.item-2 {
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        background: linear-gradient(135deg, #470404, #931414);
        order: 2;
        animation: none;
        margin: 0 5px;
    }

    .illustration-item.item-3 {
        display: flex;
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        background: linear-gradient(135deg, #931414, #470404);
        order: 3;
        animation: none;
        margin: 0 5px;
    }

    .illustration-item.item-4 {
        display: flex;
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        background: linear-gradient(135deg, #470404, #931414);
        order: 4;
        animation: none;
        margin: 0 5px;
    }

    .women-floating-illustration {
        position: relative;
        width: 100%;
        height: auto;
        top: auto;
        left: auto;
        z-index: 1;
        overflow: visible;
    }

    .illustration {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        margin-top: 35px;
        margin-bottom: 0;
        z-index: 1;
        padding: 0 5px;
        overflow: visible;
        flex-wrap: nowrap;
    }

    .women-header {
        padding-right: 0;
    }
}

@media (max-width: 1024px) {
    .women-section {
        padding: 80px 0;
    }

    .illustration-item {
        opacity: 0.6;
        width: 60px;
        height: 60px;
    }

    .illustration-item.item-1 {
        width: 60px;
        height: 60px;
        top: auto;
        left: auto;
        position: relative;
        transform: none;
        order: 1;
        margin: 0 6px;
    }

    .illustration-item.item-2 {
        width: 60px;
        height: 60px;
        bottom: auto;
        top: auto;
        right: auto;
        left: auto;
        position: relative;
        transform: none;
        order: 2;
        margin: 0 6px;
    }

    .illustration-item.item-3 {
        display: flex;
        width: 60px;
        height: 60px;
        position: relative;
        top: auto;
        right: auto;
        transform: none;
        order: 3;
        margin: 0 6px;
    }

    .illustration-item.item-4 {
        display: flex;
        width: 60px;
        height: 60px;
        bottom: auto;
        left: auto;
        position: relative;
        transform: none;
        order: 4;
        margin: 0 6px;
    }

    .geometric-element {
        opacity: 0.05;
    }

    .geo-1 {
        width: 60px;
        height: 60px;
        right: 12%;
        top: 20%;
    }

    .geo-2 {
        width: 70px;
        height: 70px;
        left: 5%;
    }

    .geo-3 {
        width: 45px;
        height: 45px;
    }

    .geo-4 {
        width: 65px;
        height: 65px;
    }

    .line-element {
        opacity: 0.4;
    }

    .women-staircase-grid {
        grid-template-columns: 1fr;
        gap: 30px;
    }

    .staircase-item.left-side,
    .staircase-item.right-side {
        justify-content: center;
    }

    .women-stats {
        gap: 30px;
    }

    .stat-divider {
        height: 50px;
    }
}

@media (max-width: 768px) {
    .women-section {
        padding: 60px 0;
    }

    .header-decoration-elements {
        top: -15px;
        left: -20px;
        width: 120px;
        height: 120px;
    }

    .deco-1 {
        width: 60px;
        height: 60px;
    }

    .deco-2 {
        width: 40px;
        height: 40px;
        top: 30px;
        left: 45px;
    }

    .deco-line-1 {
        width: 90px;
        top: 35px;
    }

    .deco-line-2 {
        width: 70px;
        top: 70px;
        left: 15px;
    }

    .women-header {
        padding-right: 0;
    }

    .women-floating-illustration {
        position: relative;
        width: 100%;
        height: auto;
        top: auto;
        left: auto;
        z-index: 1;
        overflow: visible;
    }

    .illustration {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        margin-top: 35px;
        margin-bottom: 0;
        z-index: 1;
        padding: 0 5px;
        overflow: visible;
        flex-wrap: nowrap;
    }

    .illustration-item {
        position: relative;
        opacity: 0.5;
        filter: none;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        width: 60px;
        height: 60px;
        font-size: 1.8rem;
        order: auto;
        margin: 0 5px;
    }

    .illustration-item::before {
        display: none;
    }

    .illustration-item.item-1 {
        background: linear-gradient(135deg, #931414, #470404);
        order: 1;
    }

    .illustration-item.item-2 {
        background: linear-gradient(135deg, #470404, #931414);
        order: 2;
    }

    .illustration-item.item-3,
    .illustration-item.item-4 {
        display: flex;
    }

    .illustration-item.item-3 {
        background: linear-gradient(135deg, #931414, #470404);
        order: 3;
    }

    .illustration-item.item-4 {
        background: linear-gradient(135deg, #470404, #931414);
        order: 4;
    }

    .geometric-element {
        opacity: 0.04;
        animation: none;
    }

    .geo-1 {
        width: 50px;
        height: 50px;
        right: 10%;
    }

    .geo-2 {
        width: 60px;
        height: 60px;
        left: 3%;
    }

    .geo-3 {
        width: 40px;
        height: 40px;
    }

    .geo-4 {
        width: 55px;
        height: 55px;
    }

    .line-element {
        opacity: 0.3;
        height: 1px;
    }

    .line-1 {
        width: 150px;
    }

    .line-2 {
        width: 180px;
    }

    .women-header {
        margin-bottom: 60px;
    }

    .women-stats {
        flex-direction: column;
        gap: 20px;
        margin: 30px 0 25px;
    }

    .stat-divider {
        width: 50px;
        height: 2px;
    }

    .stat-number {
        font-size: 2.5rem;
    }

    .stat-label {
        font-size: 0.9rem;
    }

    .women-description {
        font-size: 1rem;
    }

    .illustration-item {
        width: 70px;
        height: 70px;
        font-size: 2rem;
    }

    .highlight-card {
        padding: 25px;
    }

    .highlight-card h3 {
        font-size: 1.15rem;
    }

    .highlight-card p {
        font-size: 0.9rem;
    }

    .highlight-icon {
        width: 50px;
        height: 50px;
        font-size: 1.5rem;
    }
}

@media (max-width: 480px) {
    .women-section {
        padding: 40px 0;
    }

    .women-floating-illustration .illustration-item {
        opacity: 0.4;
        filter: none;
        animation: none;
    }

    .illustration-item::before {
        display: none;
    }

    .women-floating-illustration {
        position: relative;
        width: 100%;
        height: auto;
        top: auto;
        left: auto;
        z-index: 1;
        overflow: visible;
    }

    .illustration {
        position: relative;
        width: 100%;
        height: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        margin-top: 30px;
        margin-bottom: 0;
        z-index: 1;
        padding: 0 5px;
        overflow: visible;
        flex-wrap: wrap;
    }

    .illustration .illustration-item {
        position: relative;
        top: auto;
        left: auto;
        right: auto;
        bottom: auto;
        transform: none;
        width: 35px;
        height: 35px;
        font-size: 1rem;
        order: auto;
        margin: 2px;
    }

    .illustration-item.item-1 {
        background: linear-gradient(135deg, #931414, #470404);
        order: 1;
    }

    .illustration-item.item-2 {
        background: linear-gradient(135deg, #470404, #931414);
        order: 2;
    }

    .illustration-item.item-3 {
        display: flex;
        background: linear-gradient(135deg, #931414, #470404);
        order: 3;
    }

    .illustration-item.item-4 {
        display: flex;
        background: linear-gradient(135deg, #470404, #931414);
        order: 4;
    }

    .geometric-element {
        opacity: 0.03;
        animation: none;
    }

    .geo-1 {
        width: 40px;
        height: 40px;
        right: 8%;
        top: 25%;
    }

    .geo-2 {
        width: 50px;
        height: 50px;
        left: 2%;
        bottom: 30%;
    }

    .geo-3 {
        width: 35px;
        height: 35px;
    }

    .geo-4 {
        width: 45px;
        height: 45px;
    }

    .line-element {
        opacity: 0.25;
        height: 1px;
    }

    .line-1 {
        width: 120px;
        top: 35%;
    }

    .line-2 {
        width: 140px;
        bottom: 45%;
    }

    .women-header {
        margin-bottom: 40px;
    }

    .women-stats {
        gap: 15px;
        margin: 25px 0 20px;
    }

    .stat-number {
        font-size: 2rem;
    }

    .stat-label {
        font-size: 0.8rem;
    }

    .women-description {
        font-size: 0.95rem;
    }

    .illustration-item {
        width: 60px;
        height: 60px;
        font-size: 1.8rem;
    }

    .women-highlights-column {
        gap: 15px;
    }

    .highlight-card {
        padding: 20px;
    }

    .highlight-card h3 {
        font-size: 1.1rem;
        margin-bottom: 8px;
    }

    .highlight-card p {
        font-size: 0.85rem;
    }

    .highlight-icon {
        width: 45px;
        height: 45px;
        font-size: 1.3rem;
        margin-bottom: 10px;
    }

    .card-badge {
        font-size: 0.75rem;
        padding: 5px 12px;
        margin-bottom: 10px;
    }
}

@media (max-width: 380px) {
    .women-staircase-grid {
        gap: 15px;
        padding: 0 15px;
        max-width: 100%;
        width: 100%;
        box-sizing: border-box;
    }

    .staircase-item {
        width: 100%;
        max-width: 100%;
        box-sizing: border-box;
    }

    .highlight-card {
        height: auto;
        max-height: none;
        min-height: 280px;
        padding: 16px;
        width: 100%;
        box-sizing: border-box;
    }

    .highlight-icon {
        width: 40px;
        height: 40px;
        font-size: 1.3rem;
        margin-bottom: 10px;
    }

    .card-badge {
        padding: 3px 8px;
        font-size: 0.65rem;
        margin-bottom: 6px;
    }

    .highlight-card h3 {
        font-size: 0.95rem;
        margin-bottom: 8px;
        line-height: 1.3;
    }

    .highlight-card p {
        font-size: 0.75rem;
        line-height: 1.5;
    }
}

@media (max-width: 360px) {
    .women-staircase-grid {
        gap: 12px;
        padding: 0 12px;
        width: 100%;
        box-sizing: border-box;
    }

    .staircase-item {
        width: 100%;
        box-sizing: border-box;
    }

    .highlight-card {
        height: auto;
        max-height: none;
        min-height: 270px;
        padding: 14px;
        width: 100%;
        box-sizing: border-box;
    }

    .highlight-icon {
        width: 38px;
        height: 38px;
        font-size: 1.2rem;
        margin-bottom: 8px;
    }

    .card-badge {
        padding: 3px 8px;
        font-size: 0.6rem;
        margin-bottom: 4px;
    }

    .highlight-card h3 {
        font-size: 0.9rem;
        margin-bottom: 6px;
        line-height: 1.2;
    }

    .highlight-card p {
        font-size: 0.7rem;
        line-height: 1.4;
    }
}

/* Ajuste pra telas com altura de viewport menor (notebooks, ou desktop com
   janela baixa): empurra o "recorte" visível da foto pra baixo, escondendo
   mais da borda de cima (que é onde o header fixo cobre por cima) */
@media (min-width: 769px) and (max-height: 820px) {
  .parallax-container {
    background-position: center 26%;
  }
}

@media (max-width: 768px) {

    .hero-section {
        height: 70vh;
        min-height: 450px;
    }

    .parallax-container {
        background-image: url('@/assets/header-trabalhe-conosco-mini.png');
        background-position: 60% center;
    }

    .hero-title {
        font-size: 2.5rem;
    }

    .section-title h2 {
        font-size: 2rem;
    }

    .intro-text {
        font-size: 1.1rem;
    }

    .form-group.full-width {
        grid-column: span 1;
    }

    .jobs-grid {
        grid-template-columns: 1fr;
    }

    .job-card {
        min-height: 600px;
        padding: 0;
    }

    .job-description-section:first-of-type,
    .job-description-section:nth-of-type(2) {
        padding: 12px;
        margin: 10px 0;
    }

    .job-description-section {
        padding: 12px;
    }

    .complete-description-title {
        font-size: 0.85rem;
    }

    .job-description,
    .job-description-complete {
        font-size: 0.85rem;
    }

    .job-header {
        padding: 20px 20px 0;
    }

    .job-content {
        padding: 0 20px;
    }

    .job-info {
        grid-template-columns: 1fr;
        gap: 8px;
        padding: 12px;
        align-items: start;
        justify-items: center;
        text-align: center;
    }

    .job-detail {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        max-width: 200px;
        margin: 0 auto;
        padding-left: 40px;
    }

    .job-footer {
        padding: 15px 20px 20px;
    }

    .apply-button {
        justify-content: center;
    }

    .form-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .form-icon {
        font-size: 2rem;
        width: 60px;
        height: 60px;
    }

    .form-header h3 {
        font-size: 1.4rem;
    }

    .job-summary-header {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .job-summary-details {
        flex-direction: column;
        gap: 10px;
    }

    .additional-requirements h4,
    .job-benefits h4 {
        font-size: 0.9rem;
    }

    .additional-requirements li,
    .job-benefits li {
        font-size: 0.8rem;
    }

    .form-actions {
        flex-direction: column;
        gap: 10px;
    }

    .cancel-button,
    .submit-button {
        justify-content: center;
    }

    .benefit-item {
        flex-direction: column;
        align-items: center;
        text-align: center;
    }

    .benefit-icon {
        margin-bottom: 15px;
    }

    .values-grid {
        grid-template-columns: 1fr;
    }

    .checkbox-group {
        gap: 8px;
    }

    .checkbox-group label {
        font-size: 0.85rem;
        line-height: 1.4;
    }
}

@media (max-width: 576px) {

    .container {
        padding: 0 20px;
    }

    .hero-title {
        font-size: 2rem;
    }

    .hero-subtitle {
        font-size: 1.1rem;
    }

    .section-title h2 {
        font-size: 1.8rem;
    }

    .accent-line {
        width: 40px;
    }

    .value-icon {
        width: 60px;
        height: 60px;
        font-size: 1.5rem;
    }

    .value-card h3 {
        font-size: 1.3rem;
    }

    .submit-button {
        width: 100%;
    }

    .faq-question h4 {
        font-size: 1rem;
    }

    .form-icon {
        width: 60px;
        height: 60px;
        min-width: 60px;
        min-height: 60px;
    }

    .form-header h3 {
        font-size: 1.2rem;
    }

    .job-card {
        min-height: 550px;
    }

    .job-description-section:first-of-type,
    .job-description-section:nth-of-type(2) {
        padding: 10px;
        margin: 8px 0;
    }

    .job-title {
        font-size: 1.2rem;
        min-height: 2.4rem;
    }

    .job-description-section {
        padding: 10px;
    }

    .job-description-section .expand-button {
        padding: 6px 12px;
        font-size: 0.8rem;
    }

    .job-description,
    .job-description-complete {
        font-size: 0.85rem;
    }

    .job-info {
        padding: 10px;
    }

    .job-detail {
        font-size: 0.85rem;
    }
}

/* Animações adicionais */
@keyframes float {
    0% {
        transform: translateY(0px);
    }

    50% {
        transform: translateY(-10px);
    }

    100% {
        transform: translateY(0px);
    }
}

.value-icon i,
.benefit-icon i {
    animation: float 3s ease-in-out infinite;
}

/* Animação para o botão de envio */
@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(147, 20, 20, 0.7);
    }

    70% {
        box-shadow: 0 0 0 10px rgba(147, 20, 20, 0);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(147, 20, 20, 0);
    }
}

.submit-button:hover:not(:disabled) {
    animation: pulse 1.5s infinite;
}

/* Efeito de destaque para os cards de valores */
.value-card:nth-child(1) .value-icon {
    background: linear-gradient(135deg, #931414, #470404);
}

.value-card:nth-child(2) .value-icon {
    background: linear-gradient(135deg, #2C5EAE, #5596ff);
}

.value-card:nth-child(3) .value-icon {
    background: linear-gradient(135deg, #2CAE6F, #55ff9d);
}

.value-card:nth-child(4) .value-icon {
    background: linear-gradient(135deg, #AE8A2C, #ffcc55);
}

/* Efeito de hover para os itens de benefícios */
.benefit-item:hover .benefit-icon {
    transform: scale(1.2);
    transition: transform 0.3s ease;
}

/* Ajustes para dispositivos móveis */
@media (max-width: 480px) {

    .hero-title {
        font-size: 1.8rem;
    }

    .hero-subtitle {
        font-size: 1rem;
    }

    .value-card,
    .benefit-item {
        padding: 20px;
    }

    .value-icon {
        width: 50px;
        height: 50px;
        font-size: 1.3rem;
    }

    .value-card h3 {
        font-size: 1.2rem;
    }

    .benefit-icon {
        width: 40px;
        height: 40px;
        font-size: 1.2rem;
    }

    .benefit-content h4 {
        font-size: 1.1rem;
    }

    .job-title {
        font-size: 1.2rem;
    }

    .job-card {
        max-width: calc(100vw - 40px);
        width: calc(100vw - 40px);
        margin: 0 auto;
        box-sizing: border-box;
        overflow: hidden;
    }

    .no-jobs-container {
        padding: 60px 15px;
    }

    .no-jobs-icon {
        font-size: 3rem;
    }

    .no-jobs-content h3 {
        font-size: 1.5rem;
    }

    .submit-button {
        padding: 12px 20px;
        font-size: 1rem;
    }

    .modal-content {
        width: 95%;
    }

    .modal-header i {
        font-size: 2.5rem;
    }

    .modal-header h3 {
        font-size: 1.3rem;
    }

    .job-footer {
        flex-direction: column;
        gap: 15px;
        align-items: stretch;
    }

    .checkbox-group {
        gap: 6px;
    }

    .checkbox-group label {
        font-size: 0.8rem;
        line-height: 1.3;
    }

    .checkbox-group input[type="checkbox"] {
        transform: scale(1.1);
        margin-top: 2px;
    }
}

/* Correção para dispositivos pequenos */
@media (max-width: 400px) {
    .form-container {
        margin: 0 10px;
        max-width: calc(100vw - 20px);
    }

    .career-form {
        padding: 20px 25px;
    }

    .form-header {
        padding: 20px 15px;
        gap: 10px;
    }

    .form-grid {
        grid-template-columns: 1fr !important;
        gap: 15px;
    }

    .form-group {
        width: 100%;
        box-sizing: border-box;
    }

    .checkbox-group {
        gap: 8px;
        align-items: flex-start;
        flex-wrap: nowrap;
    }

    .checkbox-group input[type="checkbox"] {
        transform: scale(1.0);
        margin-top: 2px;
        min-width: 14px;
        width: 14px;
        height: 14px;
        flex-shrink: 0;
    }

    .checkbox-group label {
        font-size: 0.8rem;
        line-height: 1.3;
        max-width: calc(100% - 22px);
        overflow-wrap: anywhere;
        word-break: break-word;
    }

    .form-group input,
    .form-group select,
    .form-group textarea {
        width: 100%;
        box-sizing: border-box;
        font-size: 0.9rem;
        padding: 10px 12px;
    }

    .file-upload-label {
        font-size: 0.85rem;
        padding: 10px 12px;
        word-wrap: break-word;
    }
}

@media (max-width: 360px) {
    .form-container {
        margin: 0 5px;
        max-width: calc(100vw - 10px);
    }

    .form-header {
        padding: 15px 10px;
    }

    .form-header h3 {
        font-size: 1rem;
        line-height: 1.3;
    }

    .checkbox-group {
        gap: 5px;
    }

    .checkbox-group label {
        font-size: 0.75rem;
        line-height: 1.2;
    }

    .checkbox-group input[type="checkbox"] {
        transform: scale(1.0);
        margin-top: 1px;
    }
}
</style>

<style>
/* Modal de Sucesso */
.success-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(5px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeInOverlay 0.3s ease-out;
}

@keyframes fadeInOverlay {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.success-modal-content {
    background: white;
    border-radius: 20px;
    width: 90%;
    max-width: 500px;
    max-height: 90vh;
    overflow-y: hidden;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    animation: slideInModal 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    position: relative;
}

@keyframes slideInModal {
    from {
        transform: scale(0.7) translateY(-50px);
        opacity: 0;
    }

    to {
        transform: scale(1) translateY(0);
        opacity: 1;
    }
}

.success-animation {
    padding: 40px 30px 20px;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.checkmark-container {
    position: relative;
    display: inline-block;
}

.checkmark-circle {
    width: 80px;
    height: 80px;
    background: linear-gradient(135deg, #28a745, #20c997);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    animation: bounceIn 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) 0.2s both;
    box-shadow: 0 8px 25px rgba(40, 167, 69, 0.3);
    position: relative;
}

@keyframes bounceIn {
    from {
        transform: scale(0);
    }

    50% {
        transform: scale(1.1);
    }

    to {
        transform: scale(1);
    }
}

.checkmark-icon {
    color: white;
    font-size: 2.5rem;
    animation: checkmarkDraw 0.3s ease-out 0.5s both;
}

@keyframes checkmarkDraw {
    from {
        transform: scale(0) rotate(-45deg);
        opacity: 0;
    }

    to {
        transform: scale(1) rotate(0deg);
        opacity: 1;
    }
}

.celebration-particles {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
}

.particle {
    position: absolute;
    width: 8px;
    height: 8px;
    background: linear-gradient(135deg, #931414, #470404);
    border-radius: 50%;
    animation: particleFloat 2s ease-out infinite;
}

.particle:nth-child(1) {
    animation-delay: 0.1s;
    transform: rotate(0deg) translateX(60px);
}

.particle:nth-child(2) {
    animation-delay: 0.2s;
    transform: rotate(30deg) translateX(60px);
}

.particle:nth-child(3) {
    animation-delay: 0.3s;
    transform: rotate(60deg) translateX(60px);
}

.particle:nth-child(4) {
    animation-delay: 0.4s;
    transform: rotate(90deg) translateX(60px);
}

.particle:nth-child(5) {
    animation-delay: 0.5s;
    transform: rotate(120deg) translateX(60px);
}

.particle:nth-child(6) {
    animation-delay: 0.6s;
    transform: rotate(150deg) translateX(60px);
}

.particle:nth-child(7) {
    animation-delay: 0.7s;
    transform: rotate(180deg) translateX(60px);
}

.particle:nth-child(8) {
    animation-delay: 0.8s;
    transform: rotate(210deg) translateX(60px);
}

.particle:nth-child(9) {
    animation-delay: 0.9s;
    transform: rotate(240deg) translateX(60px);
}

.particle:nth-child(10) {
    animation-delay: 1.0s;
    transform: rotate(270deg) translateX(60px);
}

.particle:nth-child(11) {
    animation-delay: 1.1s;
    transform: rotate(300deg) translateX(60px);
}

.particle:nth-child(12) {
    animation-delay: 1.2s;
    transform: rotate(330deg) translateX(60px);
}

@keyframes particleFloat {
    0% {
        opacity: 0;
        transform: rotate(var(--rotation, 0deg)) translateX(0px) scale(0);
    }

    20% {
        opacity: 1;
        transform: rotate(var(--rotation, 0deg)) translateX(40px) scale(1);
    }

    100% {
        opacity: 0;
        transform: rotate(var(--rotation, 0deg)) translateX(80px) scale(0);
    }
}

.success-content {
    padding: 0 30px 20px;
    text-align: center;
}

.success-title {
    font-size: 1.8rem;
    font-weight: 700;
    color: #28a745;
    margin-bottom: 15px;
    animation: fadeInUp 0.5s ease-out 0.3s both;
}

.success-message {
    font-size: 1.1rem;
    color: #555;
    line-height: 1.6;
    margin-bottom: 25px;
    animation: fadeInUp 0.5s ease-out 0.4s both;
}

.success-details {
    background: #f0f0f0;
    border-radius: 12px;
    padding: 20px;
    margin: 20px 0;
    animation: fadeInUp 0.5s ease-out 0.5s both;
}

.job-applied,
.talent-bank {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 20px;
    padding: 12px;
    background: white;
    border-radius: 8px;
    border-left: 4px solid #931414;
    font-weight: 600;
    color: #333;
}

.job-applied-span, .talent-bank-span {
    background: linear-gradient(-135deg, #300303, #931414);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.job-applied i,
.talent-bank i {
    color: #931414;
    font-size: 1.2rem;
}

.next-steps h4 {
    color: #333;
    margin-bottom: 15px;
    font-size: 1rem;
    font-weight: 600;
    text-align: center;
}

.next-steps ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.next-steps li {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 0;
    color: #555;
    font-size: 0.95rem;
}

.next-steps li i {
    color: #28a745;
    font-size: 1rem;
    width: 16px;
    flex-shrink: 0;
}

.success-actions {
    padding: 20px 30px 30px;
    display: flex;
    gap: 15px;
    justify-content: center;
    animation: fadeInUp 0.5s ease-out 0.6s both;
}

.success-button {
    background: linear-gradient(135deg, #28a745, #20c997);
    color: white;
    border: none;
    padding: 12px 24px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1rem;
    box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
}

.success-button:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.secondary-button {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.8), rgba(240, 240, 240, 0.65));
    backdrop-filter: blur(20px) saturate(160%);
    -webkit-backdrop-filter: blur(20px) saturate(160%);
    color: #931414;
    border: 1px solid rgba(147, 20, 20, 0.35);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.7);
    padding: 12px 24px;
    border-radius: 25px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1rem;
}

.secondary-button:hover {
    background: #931414;
    color: white;
    transform: translateY(-2px);
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsividade do Modal */
@media (max-width: 768px) {
    .success-modal-content {
        width: 95%;
        margin: 20px;
    }

    .success-animation {
        padding: 30px 20px 15px;
    }

    .checkmark-circle {
        width: 70px;
        height: 70px;
    }

    .checkmark-icon {
        font-size: 2rem;
    }

    .success-content {
        padding: 0 20px 15px;
    }

    .success-title {
        font-size: 1.5rem;
    }

    .success-message {
        font-size: 1rem;
    }

    .success-actions {
        flex-direction: column;
        padding: 15px 20px 25px;
    }

    .success-button,
    .secondary-button {
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .particle {
        width: 6px;
        height: 6px;
    }

    .checkmark-circle {
        width: 60px;
        height: 60px;
    }

    .checkmark-icon {
        font-size: 1.8rem;
    }

    .success-title {
        font-size: 1.3rem;
    }

    .success-message {
        font-size: 0.95rem;
    }

    .success-details {
        padding: 15px;
        margin: 15px 0;
    }

    .next-steps li {
        font-size: 0.9rem;
    }
}

/* CSS global para corrigir o footer */
footer {
    position: relative !important;
    z-index: 999 !important;
    pointer-events: auto !important;
}

footer * {
    pointer-events: auto !important;
}
</style>

